






























































































































































































































































































































































































































































































































































































































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import {
  SortedColumnInfo,
  SwTable,
  TableColumnConfig,
  SwTableColumnSelection,
  TableEntry,
  GroupCollapseRequestData,
  TableEntryGroup,
  ColumnSortRequestData,
  ColumnsAdjustRequestData,
  TableEntryFloatAction,
  TableEntryExpandingEventData,
} from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { SwContentToolbar, SwContentToolbarExpand, ContentToolbarExpandFilterBlock } from '@sonicwall/unified-ui-framework/src/shared/sw-content-toolbar';
import { SwIconButton } from '@sonicwall/unified-ui-framework/src/shared/sw-icon-button';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import { SwDropMenu, DropMenuItem } from '@sonicwall/unified-ui-framework/src/shared/sw-drop-menu';
import { SwTextfield, SwExpandableTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SwChip } from '@sonicwall/unified-ui-framework/src/shared/sw-chip';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { SwTitlePane } from '@libs-uuif/shared/sw-title-pane';
import { VNode, CreateElement } from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { SwSelect, SelectOption } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { MswApiService } from '@/shared/msw-api-service';
import { SwDatetimePicker, DateTimePickerConfig } from '@sonicwall/unified-ui-framework/src/shared/sw-datetime-picker';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';
import Status from './components/status.vue';
import UUIFComponents from '@/shared/uuifComponent';
import ProvisionModal from './components/provision-modal.vue';
import AddMsspModal from './components/add-mssp-modal.vue';
import AddTenantModal from './components/add-tenant-modal.vue';
import AddProductModal from './components/add-product-modal.vue';
import PendoConsentdDialog from '@/shared/pendo-consent-dialog/pendo-consent-dialog.vue';
// import ExportcsvService from '@/shared/msw-exportcsv.service';
import ProvisionSummary from './components/provision-summary.vue';
import { tooltip, TooltipDirValues } from '@libs-uuif/shared/tooltip-dir';
import ContextMenu from './components/context-menu.vue';
import TransferProduct from './components/transfer-product.vue';
import DeleteProduct from '@/modules/msw-products/components/delete-product.vue';
import { MsspModalObject, TenantModalObject, ProductModalObject } from './types';
import { confirmService } from '@sonicwall/unified-ui-framework/src/shared/confirm-service';
import productListCache from '@/shared/cache-api-service/endpoints/product-services-data-cache';
import { InfoState , SetHelpContentIdPayload } from '@/core/core.store';
import { envCongif } from '@/shared/env.config';
import { Mutation } from 'vuex-class';
import { currentUserKey } from '@/shared/msw-constants';
// import { SetHelpContentIdPayload } from '@/core/core.store';
import { VueRenderFunction, VuexMappedMutation } from '@libs-uuif/shared/common-types';
import { SwBlockingProgress } from '@sonicwall/unified-ui-framework/src/shared/sw-blocking-progress';
import { SetNewProductModalObjectPayload, SetAnotherProductModalObjectPayload } from './msw-tenant-management.store';
import _ from 'lodash';
import { SwStatusFlag } from '@sonicwall/unified-ui-framework/src/shared/sw-status-flag';
import { SwIconTabDivider } from '@sonicwall/unified-ui-framework/src/shared/sw-icon-tab';
import { SwModal } from '@sonicwall/unified-ui-framework/src/shared/sw-modal';
const cssPrefix = 'msw-tenants';

@Component({
  components: {
    SwTable,
    SwTableColumnSelection,
    SwContentToolbar,
    SwContentToolbarExpand,
    SwIconButton,
    SwIcon,
    SwDropMenu,
    SwExpandableTextfield,
    SwSelect,
    SwTextfield,
    SwChip,
    SwButton,
    SwTitlePane,
    SwCheckbox,
    Status,
    ProvisionModal,
    AddMsspModal,
    AddTenantModal,
    AddProductModal,
    ProvisionSummary,
    ContextMenu,
    TransferProduct,
    DeleteProduct,
    PendoConsentdDialog,
    SwBlockingProgress,
    ...UUIFComponents,
    SwStatusFlag,
    SwIconTabDivider,
  },
  directives: {
    tooltip,
  },
})

export default class MswTenantManagementPage extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Mutation
  setHelpContentId: VuexMappedMutation<SetHelpContentIdPayload>;
  @Mutation
  readonly setNewProductModalObject: VuexMappedMutation<SetNewProductModalObjectPayload>;
  @Mutation
  readonly setAnotherProductModalObject: VuexMappedMutation<SetAnotherProductModalObjectPayload>;
  tableData: TableEntryGroup[] = [];
  filteredData: TableEntryGroup[] = [];
  expandedEntries: Set<string> = new Set();
  shadowExpandedEntries: string[] = [];
  openFilterList: boolean = false;
  searchExpanded: boolean = false;
  searchText: string = '';
  searchTextFilter: string = '';
  expandVisible: boolean = false;
  filterExpandVisible: boolean = false;
  mssp: any = '';
  tenant: any = '';
  status:any = 'ALL';
  collapsedGroups: string[] = [];
  exportMenuOpened: boolean = false;
  exportMenuItems: DropMenuItem[] = [
    { id: 'csv', content: String(this.$t('tenantMgmt.page.exportCSV')) },
    { id: 'xls', content: String(this.$t('tenantMgmt.page.exportXLS')) },
  ];
  mustIncludeColumnKeys: string[] = ['msspp', 'tenant', 'expand', 'friendlyName', 'serNo', 'product', 'service', 'units', 'expirydate', 'action'];
  selectedOption: string = 'recent';
  showColumnFilter: boolean = false;
  selectedColumnFilters: any[] = [];
  columnFilterText: string = '';
  isColFilterInEditMode: boolean = true;
  sortedColumns: SortedColumnInfo = {
    colKey: '',
    ascending: true,
  };
  sortCompareCollator = new Intl.Collator(undefined, { sensitivity: 'accent', usage: 'sort' });
  msspProducts: any = {};
  msspStat:any = {};
  // msspDetails:any = {};
  startDate = '';
  expiryDate = '';
  captureClient:  any = [];
  cas:  any = [];
  edge:  any = [];
  email:  any = [];
  nsv:  any = [];
  smav:  any = [];
  selectedProduct: any = [];
  selectedService: any = [];
  premium:  any = [];
  casAd:  any = [];
  casBasic:  any = [];
  edgeAd:  any = [];
  epss:  any = [];
  min: string = '0';
  max: string = '99999';
  startdate: string = '';
  expirydate:string  = '';
  menuOpened:boolean = false;
  enableProvisionModal: boolean = false;
  enableMsspFormModal: boolean = false;
  enableTenantFormModal: boolean = false;
  enableProductModal: boolean = false;
  enableProductSummary: boolean = false;
  msspType: string = '';
  msspModalMode: string = '';
  tenantModalMode: string = '';
  productModalMode: string = '';
  showRename: boolean = false;
  enableTenantEdit: string = '';
  friendlyNameEdit: string = '';
  fName: string = '';
  enableMsspEdit: string = '';
  msspPrefilter: any = {};
  contextDrop: any = [];
  isOpenDeleteModal: boolean = false;
  openMultiProductAction: 'transfer'|'delete'|'' = '';
  selectedProductsForActions: any = [];
  customerToExcludeInTransfer: string = '';
  customersList: any[] = [];
  filterOptionsData: any = [];
  provisionObj = {
    provisionMSSP: '',
    provisionTenant: '',
    provisionProduct: '',
    showAccessManagement: '',
  };
  todayDate: any = '';
  msspfilterList: SelectOption[] = [];
  customColumnConfig: TableColumnConfig[] = [];
  infiniteTableData:  TableEntryGroup[] = [];
  selectedColumns: any = {};
  selectingColumn: boolean = false;
  filtersClicked: boolean = true;
  doCall: boolean = false;
  msspPrefilterData: any = {};
  ifColumnSelected: boolean = true;
  ifClicked: boolean = false;
  fullCustomerist: any = [];
  msspFiltered: boolean = false;
  tenantFiltered: boolean = false;
  selectedMSSPID: any = '';
  selectedTenantID: any = '';
  allMsspClicked: boolean = false;
  msspOnTenantSelected: string = '';
  refreshClicked: boolean = false;
  visible: boolean = false;
  isLargeCustomer:boolean = false;
  onMsspClick:boolean = false;
  onTenantClick: boolean = false;
  msspSelected: string = '';
  tenantSelected: string = '';
  loaded: boolean = false;
  isMastermssp: boolean = true;
  adjustedColumns: ColumnsAdjustRequestData = {};

  showPendoConsentModal: boolean = false;
  defaultmssp: any = '';
  defaultTenant: any = '';
  selProductRegion: string = '';
  textExpanded: boolean = false;
  data: any[] = [];
  expandableMod = 2;
  needtoBeExpanded: any[] = [];
  isServiceSorted: boolean = false;
  addressWarning: string = '';
  withoutExpand: boolean = false;
  collapsed: any = [];
  msspChanged: boolean = false;
  filterChanged: boolean = false;
  onEntryExpanding(data: TableEntryExpandingEventData) {
    console.warn('onEntry', data, this.withoutExpand, this.filterChanged, this.msspChanged);
    data.expanding = this.needtoBeExpanded.includes(data.entryKey) && data.expanding ? false :
    !this.needtoBeExpanded.includes(data.entryKey) && (this.msspChanged || this.withoutExpand || this.filterChanged)  ? data.expanding :
    this.needtoBeExpanded.includes(data.entryKey) && (this.msspChanged || this.withoutExpand || this.filterChanged)  ? !data.expanding :
     !this.needtoBeExpanded.includes(data.entryKey) && !data.expanding ? true : data.expanding;
    this.onMoveOut();
    const expanddata = (this.data);
    let itemObj: any = [];
    let finalData: any = [];
    if (data.expanding) {
      itemObj = [];
      if (!this.needtoBeExpanded.includes(data.entryKey)) {
        this.needtoBeExpanded.push(data.entryKey);
        this.collapsed.splice(this.collapsed.indexOf(data.entryKey), 1);
        // console.warn('need1', this.needtoBeExpanded);
      }
      // expanddata.map((ele: any) => {
      //   // console.warn('getMultiple');
      //   itemObj.push(this.getMultipleEntries(ele, data));
      // });
      // console.warn('sure', itemObj);
    } else {
      // let children: any = {};
      // let collapsedentries : any = [];
      itemObj = [];
      if (this.needtoBeExpanded.length >= 1) {
        const index = this.needtoBeExpanded.indexOf(data.entryKey);
        const isAvail = expanddata.filter((ele: any) => {
          let check = false;
          if (ele.entries.length > 0) {
            check = (ele.entries[0]._key.split('.'))[0] === (data.entryKey.split('.'))[0];
          }
          return check;
        });
        // console.warn('isAvail', isAvail);
        if (index !== -1 && isAvail.length >= 1) {
          this.collapsed.push(data.entryKey);
          this.needtoBeExpanded.splice(index, 1);
        }
        // console.warn('inentry', this.needtoBeExpanded, index, data.entryKey);
      }
      // expanddata.map((ele: any) => {
      //   let sNo = '';
      //   collapsedentries = [];
      //   children = ele.entries.filter((item: any) => item._key === data.entryKey) ? ele : '';
      //   // console.warn('children', children, ele.tenant);
      //   if (children.entries.length !== 0) {
      //     children.entries.map((item: any) => {
      //       sNo = item._key === data.entryKey ? item.serNo : sNo;
      //       if (item._expandable && item.serNo === sNo) {
      //         // console.warn('sNo', sNo);
      //         item.service = 'Multiple';
      //         item.units = 'Multiple';
      //         item.expirydate = 'Multiple';
      //         item.startdate = 'Multiple';
      //         item.firmware = 'Multiple';
      //         item.usedNodeCount = 'Multiple';
      //         item.status = 'Multiple';
      //         item.multiple = true;
      //         // console.warn('item1', item);
      //         collapsedentries.push(item);
      //       } else if (item._expandable && item.serNo !== sNo) {
      //         // console.warn('getMultiple1');
      //         const itemobj = this.getMultipleEntries(ele, data);
      //         // console.warn('itemobj', itemobj);
      //         const item1 = itemobj.entries
      //         .filter((obj:any) => obj.serNo === item.serNo);
      //         // console.warn('item2', item1);
      //         item1.map((obj:any) => collapsedentries.push(obj));
      //       } else if (!item.highlight && item.serNo !== sNo) {
      //         // console.warn('item3', item);
      //         collapsedentries.push(item);
      //       }
      //     });
      //   }
      //   ele.entries = [];
      //   ele.entries = collapsedentries;
      //   // console.warn('final ele', collapsedentries, ele);
      //   itemObj.push(ele);
      // });
    }
    expanddata.map((ele: any) => {
      // console.warn('getMultiple');
      itemObj.push(this.getMultipleEntries(ele, data));
    });
    finalData = [...finalData, ...itemObj];
    // console.warn('expandData', expanddata, 'final', finalData);
    this.filteredData = finalData;
    this.setMultiple();
    this.withoutExpand = false;
    this.msspChanged = false;
    this.filterChanged = false;
    this.infiniteTableData = this.filteredData;
  }
  getMultipleEntries(ele: any, data: any) {
    let entry: any = [];
    let itemObj: any = [];
    let sNo: any = [];
    // console.warn('needed', this.needtoBeExpanded);
    // console.warn(data);
    const collapsedData: any = [];
    this.formatTableData()
    .map((item: any) => {
      const picked = item.entries.find((obj: any) => obj._key === data.entryKey);
      if (picked) {
        sNo = picked.serNo;
      }
      item.entries.map((obj: any) => {
        // if (obj._key === data.entryKey) {
        //   console.warn('entries', item.entries);
        //   sNo = obj.serNo;
        // }
        if (obj.serNo === sNo) {
          collapsedData.push(obj);
        }
      });

      // console.warn('collapse', collapsedData);
    });
    if (collapsedData) {
      collapsedData.sort(this.columnSorter);
      if (collapsedData[0]._key !== data.entryKey) {
        collapsedData.reverse();
      }
      if (data.expanding && !this.needtoBeExpanded.includes(collapsedData[0]._key)) {
        this.needtoBeExpanded.splice(this.needtoBeExpanded.indexOf(collapsedData[1]._key), 1, collapsedData[0]._key);
      }
    }
    entry = ele.entries;
    let count = 0;
    ele.entries.map((itr: any, index: any) => {
      // console.warn('it', entry);
      if (itr._key === data.entryKey && count === 0) {
        if (data.expanding) {
          switch (collapsedData.length) {
            case 2:
              entry.splice(index, 1, collapsedData[0], collapsedData[1]);
              count = + 1;
              break;
            case 3:
              entry.splice(index, 1, collapsedData[0], collapsedData[1], collapsedData[2]);
              count = + 1;
              break;
            case 4:
              entry.splice(index, 1, collapsedData[0], collapsedData[1], collapsedData[2], collapsedData[3]);
              count = + 1;
              break;
          }
          // console.warn('itr1', entry);
        } else {
          itr.service = 'Multiple';
          itr.units = 'Multiple';
          itr.expirydate = 'Multiple';
          itr.startdate = 'Multiple';
          itr.firmware = 'Multiple';
          itr.usedNodeCount = 'Multiple';
          itr.status = 'Multiple';
          itr.multiple = true;
          switch (collapsedData.length) {
            case 2:
              entry.splice(index + 1, 1);
              break;
            case 3:
              entry.splice(index + 1, 2);
              break;
            case 4:
              entry.splice(index + 1, 3);
              break;
          }
          // console.warn('itr2', entry);
        }
      }
    });

    ele.entries = [];
    ele.entries = entry;
    itemObj = ele;
    // this.formatTableData()
    // .map((elem:any) => {
    //   if (elem.key === ele.key) {
    //     elem.entries.map((item: any) => {
    //       const pushEntry: any = ele.entries.filter((item1: any) => item1._key ===  item._key)[0];
    //       sNo = this.needtoBeExpanded.includes(item._key) && pushEntry?.serNo ? item.serNo : sNo;
    //       if (item.serNo === sNo) {

    //         // console.warn('push1', item.friendlyName, item.service, item.serNo);
    //       } else {
    //         if (pushEntry?._key) {
    //           entry.push(pushEntry);
    //           // console.warn('push2', pushEntry.friendlyName, pushEntry.service, pushEntry.serNo);
    //         }
    //       }
    //       // if (item.service === 'Multiple' && data.entryKey === item._key) {
    //       //   const sNo = item.serNo;
    //       //   elem.entries.map((item1: any) => {
    //       //     if (sNo === (item1.serNo)) {
    //       //       entry.push(item1);
    //       //     }
    //       //   });
    //       // } else {
    //       //   entry.push(item);
    //       // }
    //     });
    //     // console.warn('entry', entry);
    //     elem.entries = [];
    //     elem.entries = entry;
    //     itemObj = elem;
    //   }
    // });
    return itemObj;
  }
  // pendo: any;
  navigateToAccessMgmt() {
    this.$router.push({ name: 'msspAccessManagement' });
    // .then(() => {
    window.parent.postMessage({ redirectUrl : '/m/feature/mssp-access-management' }, '*');
    // });
  }

  onRequestAdjustColumn(data: ColumnsAdjustRequestData) {
    this.adjustedColumns = data;
  }
  get isOpenTransferModal() {
    return this.openMultiProductAction === 'transfer';
  }
  onRequestSorting(data: ColumnSortRequestData) {
    /** for now, we only support single-column sorting */
    // const index = this.sortedColumns.findIndex(col => (col.colKey === data.colKey));
    // if (index < 0) {
    //   if (data.cancel) { return; }
    //   this.sortedColumns.splice(0);
    //   this.sortedColumns.push({
    //     colKey: data.colKey,
    //     ascending: !!data.ascending,
    //   });
    // } else {
    //   if (data.cancel) {
    //     this.sortedColumns.splice(index, 1);
    //     this.sortedColumns.push({
    //       colKey: data.colKey,
    //       ascending: !!data.ascending,
    //     });
    //     return;
    //   }
    //   this.sortedColumns[index].ascending = !!data.ascending;
    // }
    this.sortedColumns.colKey = data.colKey;
    this.sortedColumns.ascending = data.ascending === true;
    if (data.colKey === 'msspp' || data.colKey === 'tenant') {
      this.filteredData.sort(this.columnSorter);
      if (!this.sortedColumns.ascending) {
        this.filteredData.sort(this.columnSorter)
        .reverse();
      }
    } else {
      this.sortGroups();
    }
    // console.warn('check', this.collapsed);
    // this.needtoBeExpanded = [];
    this.addExpandables();
    // console.warn('expanded', this.needtoBeExpanded);
    this.data = this.filteredData;
    this.setMultiple();
  }
  addExpandables() {
    this.filteredData.map((obj:any) => {
    // const entry: any[] = [];
      if (obj.entries.length > 1) {
        obj.entries.map((ele: any) => {
          const spliced = this.collapsed.includes(ele._key.slice(0, -1)
          .concat('0')) || this.collapsed.includes(ele._key.slice(0, -1)
          .concat('1'))
           || this.collapsed.includes(ele._key.slice(0, -1)
           .concat('2')) || this.collapsed.includes(ele._key.slice(0, -1)
           .concat('3'));
          if (ele._expandable && !ele.multiple && !spliced && !this.needtoBeExpanded.includes(ele._key)) {
            this.needtoBeExpanded.push(ele._key);
          }
        });
      }
    });
  }
  get columnSorter(): (a: any, b: any) => number {
    return (a: any, b: any) => {
      return this.sortCompareCollator.compare(a[this.sortedColumns.colKey], b[this.sortedColumns.colKey]);
    };
  }
  get finalData(): TableEntryGroup[] {
    return this.filteredData;
  }

  get getShowErrMsg() {
    const errorFlag = this.$store.getters['TenantManagementStoreModule/getProductModalFurtherValidation'];
    return errorFlag;
  }
  @Watch('getShowErrMsg')
  private onChangeErrMsg() {
    this.centerProductModal();
  }

  deleteTenant(tenant: any) {
    const req = {
      productGroupList: [
        {
          productGroupId: tenant.productGroupId,
        },
      ],
      bsendMail: true,
      bisMSSP: true,
    };
    this.$store.dispatch('MswProductsStoreModule/deleteTenant', req)
    .then((res) => {
      this.$store.commit('stopLoading');
      if (res.operationStatus === 'OK') {
        const message: InfoState = { infoType: 'success', infoMsg: String(this.$t('tenantMgmt.page.messages.tenantDelete')) };
        this.$store.commit('enqueueMessage', message);
        this.tenant = this.isLargeCustomer ? this.tenant : this.tenantSelected;
        // console.warn('te6', this.isLargeCustomer, this.tenant);
        this.getTenantMgmtData();
      } else {
        const message: InfoState = { infoType: 'high', infoMsg: res.msgDesc };
        this.$store.commit('enqueueMessage', message);
      }
    });
  }

  renderTenantLabel(tenant: any): VueRenderFunction {
    return (h: CreateElement): VNode => { // tslint:disable-line
      // console.warn(h);
      return (
        <div style={'width: 100%; display: flex; align-items: center; justify-content: space-between'}>
          { tenant?.tenant }
          { tenant?.deleteTenant === 'YES' ?
            <SwIconButton name="tenant" icon="trash" theme="dark" color="white" nativeOn-click={() => {
              confirmService.confirm({
                status: 'informational',
                title: 'Confirmation',
                message: String(this.$t('tenantMgmt.page.messages.tenDeleteSure')),
                buttons: [{ key: 'cancel', name: String(this.$t('tenantMgmt.page.cancel')) }, { key: 'ok', name: String(this.$t('tenantMgmt.page.ok')) }],
              })
              .then((key) => {
                if (key === 'ok') {
                  this.deleteTenant(tenant);
                }
              });
            }}
            v-tooltip={{ compact: true, content: String(this.$t('tenantMgmt.page.tooltips.deleteTenant')), placement: 'bottom' }}
            />
          : <div/>
          }
      </div>
     ) as VNode;
    };
  }

  get tenantOptions(): SelectOption[] {
    const tenants: SelectOption[] = [];
    // const customers: any[] = [];
    let tenantOps:any = '';
    if (this.msspPrefilter.hasOwnProperty('MSSPs')) {
      let tenantOption = [];
      // console.warn('obj', this.msspOptions, this.mssp);
      const mssp: any = this.msspOptions.find((obj: any) => obj.id === (this.mssp));
      // console.warn('mssp', mssp);
      tenantOption = this.msspPrefilter.MSSPs.filter((obj:any) => obj.MSSPName === mssp.value);
      tenantOption.map((val:any) => {
        if (val.Tenants) {
          // tenants = [];
          val.Tenants.map((vall:any) => {
            if (vall.isDefault === 'YES') {
              tenants.push({
                id: vall.productGroupId.toString(),
                // label: vall.TenantName,
                label: vall.TenantName,
                value: vall.TenantName,
              });
            } else {
              tenants.push({
                id: vall.productGroupId.toString(),
                // label: vall.TenantName,
                label: vall.TenantName,
                value: vall.TenantName,
              });
            }
            // tenants.push({
            //   id: vall.TenantID.toString(),
            //   // label: vall.TenantName,
            //   label: this.renderTenantLabel(vall),
            //   value: vall.TenantName,
            // });
            // customers.push({ productGroupName: vall.TenantName, productGroifupId: vall.TenantID });
            // this.tenant = '-1';
            this.tenantSelected = vall.isSelected === 'YES' ? vall.productGroupId.toString() : this.tenant === '-2' ? this.tenant : this.tenantSelected;
            this.tenant = vall.isSelected === 'YES' && this.tenant === '' ? vall.productGroupId.toString() : this.tenant;
          });
          // tenantOps = [...tenantOps, ...tenants];
          // this.customersList = [...customers];
        }
      });
      tenantOps = [...tenantOps, ...tenants];
      // if (tenantOps.length === 2 && !this.isLargeCustomer) {
      //   this.tenant = tenants[0].id;
      //   this.tenantFiltered = true;
      // }
      // this.tenant = this.isLargeCustomer && this.tenant === 'tenant' ? tenants[0].id : this.tenant;
      // console.warn('te1', this.isLargeCustomer, this.tenant, this.onTenantClick);
    }
    return [...tenantOps];
  }
  get statusOptions(): SelectOption[] {
    const statuses:any = [];
    if (this.msspPrefilter.hasOwnProperty('Status') && this.msspPrefilter.Status.length > 0) {
      this.msspPrefilter.Status.forEach((ele:any) => {
        statuses.push({
          id: ele.status,
          label: ele.statusText,
          value: ele.status,
        });
      });
    }
    return statuses;
  }
  deleteMssp(MSSP: any) {
    const req = {
      msspId: MSSP.MSSPID,
    };
    this.$store.dispatch('MswProductsStoreModule/deleteMssp', req)
    .then((res) => {
      this.$store.commit('stopLoading');
      if (res.operationStatus === 'OK') {
        const message: InfoState = { infoType: 'success', infoMsg: res.msgDesc };
        this.$store.commit('enqueueMessage', message);
        this.mssp = this.isLargeCustomer ? this.mssp : this.msspSelected;
        this.getTenantMgmtData();
      } else {
        const message: InfoState = { infoType: 'high', infoMsg: res.msgDesc };
        this.$store.commit('enqueueMessage', message);
      }
    });
  }

  renderMSSPLabel(MSSP: any): VueRenderFunction {
    const mssp = this.msspPrefilter.MSSPs.filter((val:any) => val.MSSPName === MSSP.msspp)[0];
    // console.warn('ren', mssp);
    return (h: CreateElement): VNode => { // tslint:disable-line
      return (
        <div style={'width: 100%; display: flex; align-items: center; justify-content: space-between'}>
          { mssp?.deleteMSSP === 'YES' ?
            <SwIconButton name="tenant" icon="trash" theme="dark" color="white" nativeOn-click={() => {
              confirmService.confirm({
                status: 'informational',
                title: 'Confirmation',
                message: String(this.$t('tenantMgmt.page.messages.deleteMssp')),
                buttons: [{ key: 'cancel', name: String(this.$t('tenantMgmt.page.cancel')) }, { key: 'ok', name: String(this.$t('tenantMgmt.page.ok')) }],
              })
              .then((key) => {
                if (key === 'ok') {
                  this.deleteMssp(MSSP);
                }
              });
            }}
            v-tooltip={{ compact: true, content: String(this.$t('tenantMgmt.page.tooltips.deleteMssp')), placement: 'bottom' }}
            />
          : <div/> }
      </div>
     ) as VNode;
    };
  }

  get msspOptions(): SelectOption[] {
    const mssps: SelectOption[] = [];
    let msspOps: any = '';
    if (this.msspPrefilter.hasOwnProperty('MSSPs')) {
      this.msspPrefilter.MSSPs.map((val:any) => {
        mssps.push({
          id: val.MSSPID.toString(),
          // label: val.MSSPName,
          label: val.MSSPName,
          value: val.MSSPName,
        });
        // this.mssp = '-1';
        this.mssp = val.isSelected === 'YES' && this.mssp === '' ? val.MSSPID.toString() : this.mssp;
        this.msspSelected = val.isSelected === 'YES' ? val.MSSPID.toString() : this.msspSelected;
      });
      this.msspfilterList = [];
      this.msspPrefilter.MSSPs.map((val:any) => {
        this.msspfilterList.push({
          id: val.MSSPID.toString(),
          label: val.MSSPName,
          value: val.MSSPStatus,
        });
      });
      // if (mssps.length === 1 && !this.isLargeCustomer) {
      //   this.mssp = mssps[0].id;
      //   this.msspFiltered = true;
      // }
      // this.tenant = this.isLargeCustomer && this.mssp === 'mssp' ? 'tenant' : this.tenant;
      // this.mssp = this.isLargeCustomer && this.mssp === 'mssp' ? mssps[0].id : this.mssp;
      msspOps = [...msspOps, ...mssps];
    }
    return [...msspOps];
  }
  get msspColumnConfig (): TableColumnConfig[] {
    return this.columnConfig;
  }

  onToggleFilterExpand() {
    this.expandVisible = !this.expandVisible;
    this.onMoveOut();
  }
  selectedColumnKeys: string[] = this.msspColumnConfig.map((col:any) => {
    if (col.key === 'msspp' || col.key === 'tenant' || col.key === 'expand' || col.key === 'friendlyName' || col.key === 'serNo'
    || col.key === 'product' || col.key === 'service' || col.key === 'units' || col.key === 'action' || col.key === 'status' || col.key === 'expirydate') {
      return col.key;
    }
  });
  onColumnSelect(e: any) {
    this.onMoveOut();
    this.ifColumnSelected = true;
    this.filtersClicked = false;
    this.selectedColumnKeys = e;
    // console.warn('sel1', this.selectedColumnKeys);
  }
  get getCustomisedColumns() {
    return this.$store.getters['TenantManagementStoreModule/getCustomisedColumns'];
  }
  getSelectedColumnList() {
    return new Promise((res) => {
      // Persisted column config might be fetched from API later so we can wrap it in promise for now
      const tempData: TableColumnConfig[] = [];
      this.columnConfig.forEach((columnEntry: TableColumnConfig) => {
        if (!this.mustIncludeColumnKeys.includes(columnEntry.key)) { // do not include columns that should always be visible
          tempData.push(columnEntry);
        }
      });
      // this.selectedColumnKeys = tempData;
      this.customColumnConfig = tempData;
      res(true);
    });
  }
  get selectedColumnsConfig(): TableColumnConfig[] {
    const selected:any = this.selectedColumnKeys.filter(ele => ele !== null && ele !== undefined);
    this.selectingColumn = true;
    if (!this.filtersClicked) {
      if (selected.length >= this.mustIncludeColumnKeys.length - 1) {
        this.onSaveApply('tenantChange');
      }
    }
    return this.msspColumnConfig.filter(col => (this.selectedColumnKeys.includes(col.key)));
  }
  products: any = [];
  services:any = [];
  filterBlockGrid: ContentToolbarExpandFilterBlock[][] = [
    [
      { title: String(this.$t('tenantMgmt.page.prod')), content: this.productFilter, width: 250 },
      { title: String(this.$t('tenantMgmt.page.serv')), content: this.serviceFilter, width: 250 },
      { title: String(this.$t('tenantMgmt.page.licnce')), content: this.unitsFilter, width: 270 },
      { title: String(this.$t('tenantMgmt.page.startDate')), content: this.startDateFilter, width: 250 },
      { title: String(this.$t('tenantMgmt.page.expiry')), content: this.expiryDateFilter, width: 250 },
    ],
  ];
  singlePickerConfig: DateTimePickerConfig = {
    placeholder: String(this.$t('tenantMgmt.page.placeholder.strtDate')),
    dateFormat: 'MM/DD/YYYY',
    onDayClick: this.onDayClick1,
  };
  pickerConfig: DateTimePickerConfig = {
    placeholder: String(this.$t('tenantMgmt.page.placeholder.epiry')),
    dateFormat: 'MM/DD/YYYY',
    onDayClick: this.onDayClick2,
  };
  onDayClick1(date:any) {
      // // console.warn('day clicked..');
    const eDate = new Date(date);
    this.startdate = String(eDate.getMonth())
    .concat('/', String(eDate.getDate()), '/', String(date.getFullYear()));
  }
  onDayClick2(date:any) {
    const eDate = new Date(date);
    this.expirydate = String(eDate.getMonth())
    .concat('/', String(eDate.getDate()), '/', String(date.getFullYear()));
  }
  tenantSelection() {
    if (this.mssp === this.defaultmssp && this.tenant !== this.defaultTenant) {
      this.tenant = this.defaultTenant;
    } else {
      const isTenantAvail = this.tenantOptions.filter((val: any) => val.id === this.tenant);
      // console.warn('ids', isTenantAvail);
      this.tenant = isTenantAvail.length !== 0 ? this.tenant : this.tenantOptions.length === 0 ? '0' : this.tenantOptions[0].id;
    }
    return this.tenant;
  }
  onMsspOptionChange() {
    this.onMsspChange();
    this.onSaveApply('');
  }
  onMsspChange() {
    let mssp:any = {};
    if (this.mssp !== '-1' && this.isMastermssp) {
      if (this.isLargeCustomer) {
        this.tenantSelection();
        this.visible = true;
        this.getMsspProductDetails();
      }
      mssp = this.msspOptions.find((obj: any) => obj.id === (this.mssp));
      if (this.tenantOptions.length > 2) {
        this.tenant = this.isLargeCustomer ? this.tenant : this.tenantSelected;
        // console.warn('te2', this.isLargeCustomer, this.tenant);
        this.tenantFiltered = false;
      }
      if (this.tenant === '-1') {
        this.filteredData = this.tableData.filter((obj:any) => obj.msspp === mssp.value && obj.FilterGrpId === -1);
      } else {
        this.filteredData = this.tableData.filter((obj:any) => obj.msspp === mssp.value);
      }
      this.filterOptionsData = this.filteredData;
      this.allMsspClicked = false;
      this.msspFiltered = true;
      this.msspChanged = true;
    } else if (this.mssp === '-1') {
      if (this.msspOptions.length === 2) {
        this.msspFiltered = true;
      } else {
        this.msspFiltered = false;
      }
      this.tenant = this.isLargeCustomer ? this.tenant : this.tenantSelected;
      if (this.tenant === '-1') {
        this.filteredData = this.tableData.filter((obj:any) => obj.FilterGrpId === -1);
      } else {
        this.filteredData = this.tableData;
      }
      this.filterOptionsData = this.filteredData;
      // if (this.tenant !== 'tenant') {
      //   this.allMsspClicked = true;
      //   // this.onTenantChange();
      //   const tenant: any = this.tenantOptions.find((obj: any) => obj.id === (this.tenant));
      //   this.filteredData = this.tableData.filter((obj:any) => obj.tenant === tenant.value);
      //   this.filterOptionsData = this.filteredData;
      // }
    }
    // this.msspOnTenantSelected = this.mssp;
    this.onMoveOut();
    this.applyTextFilter();
    this.applyColumnFilters();
    this.data = this.filteredData; // data to be used for expanding..newly created to hold the filters and dropdown change
    // console.warn('da1', this.data);
    this.infiniteTableData = this.filteredData;
  }
  onTenantOptionChange() {
    this.onTenantChange();
    this.onSaveApply('tenantChange');
  }
  onTenantChange() {
    const originalData = _.cloneDeep(this.tableData);
    if (this.tenant !== '-1' && this.tenant !== '-2') {
      const tenant: any = this.tenantOptions.find((obj: any) => obj.id === (this.tenant));
      this.filteredData = originalData.filter((obj:any) => obj.tenantId === tenant.id);
      this.onRequestSorting(this.sortedColumns);
      this.filterOptionsData = this.filteredData;
      this.withoutExpand = true;
      if (this.mssp === '-1') {
        this.allMsspClicked = false;
      }
      // when tenant is selected and All Mssp is selected showing All MSSPs but sending the corresponding mssp to product page on provision
      // // console.warn(this.tenant);
      const msspObject = (this.msspPrefilter.MSSPs.filter((ele: any) => {
        if (ele.Tenants) {
          const isEle: any = ele.Tenants.filter((tent: any) => tent.productGroupId.toString() === this.tenant);
          if (isEle.length === 1) {
            return ele;
          }
        }
      }));
      this.msspOnTenantSelected = msspObject[msspObject.length - 1].MSSPID.toString();
      this.mssp = !this.allMsspClicked  ? this.msspOnTenantSelected : this.mssp;
      this.msspFiltered = true;
      this.tenantFiltered = true;
    } else if (this.tenant === '-2') {
      this.filterOptionsData = originalData;
      if (this.mssp !== '-1') {
        this.onMsspChange();
      }
      this.tenantFiltered = false;
    } else if (this.tenant === '-1') {
      let dataFiltered = originalData;
      // console.warn('pic', dataFiltered);
      if (this.mssp !== '-1' && this.isMastermssp) {
        this.onMsspChange();
        dataFiltered = this.filteredData;
      }
      this.filteredData = dataFiltered.filter((obj:any) => obj.FilterGrpId === -1);
      // console.warn(this.tableData.filter((obj:any) => obj.FilterGrpId === -1), this.filteredData, 'kept');
      this.tenantFiltered = false;
      this.filterOptionsData = this.filteredData;
    }
    if (this.isLargeCustomer) {
      this.visible = true;
      this.getMsspProductDetails();
    }
    // this.withoutExpand = true;
    this.onMoveOut();
    this.applyTextFilter();
    this.applyColumnFilters();
    // console.warn('you');
    this.data = this.filteredData; // data to be used for expanding..newly created to hold the filters and dropdown change
    // console.warn('da2', this.data);
    // console.warn('inTenantChange', this.filteredData);
    this.filterStatusForTableData();
    // console.warn('333');
    this.infiniteTableData = this.filteredData;
  }
  onStatusChange() {
    // this.applyTextFilter();
    // this.applyColumnFilters();
    this.onTenantChange();
    this.filterStatusForTableData();
    this.onSaveApply('tenantChange');
  }
  filterStatusForTableData() {
    const statusObj: any = this.statusOptions.find((obj: any) => obj.id === (this.status));
    if (statusObj.value && statusObj.value !== 'ALL') {
      /* tslint:disable-next-line */
      const tableDataToBeFiltered:any [] = _.cloneDeep(this.filteredData);
      const tempDataToBeFiltered:any[] = tableDataToBeFiltered.filter((ele:any) => ele.entries.length > 0);
      this.filteredData = tempDataToBeFiltered.filter((item:any) =>  {
        // debugger;
        let obj:any = [];
        const entry = item.entries.filter((item1: any) => {
          // item1._expandable = false;
          return statusObj.value === item1.statusCode;
        });
        if (entry.length > 0) {
          obj = item;
          obj.entries = entry;
          // debugger;
          return obj;
        }
      });
      // this.filteredData = tempDataToBeFiltered.filter((item:any) => item.entries.filter((item1: any) => statusObj.value === item1.statusCode));
      // console.warn('filteredData', this.filteredData);
      this.filterChanged = true;
    }
    // console.warn('inFilterStatus', this.filteredData);
    // console.warn('mate');
    // this.setMultiple();
    console.warn('pic5', this.filteredData);
    this.data = this.filteredData;
    // console.warn('jjjj');
    // console.warn('da3', this.data);
    this.onRequestSorting(this.sortedColumns);
    this.infiniteTableData = this.filteredData;
    // console.warn('2222');
    // console.warn('infiniteTableData', this.infiniteTableData);
  }
  onRequestGroupCollapse(data: GroupCollapseRequestData) {
    if (data.collapsing) {
      if (!this.collapsedGroups.includes(data.groupKey)) {
        this.collapsedGroups.push(data.groupKey);
      }
    } else {
      const index = this.collapsedGroups.findIndex(k => (k === data.groupKey));
      if (index >= 0) {
        this.collapsedGroups.splice(index, 1);
      }
    }
  }
  get headerColumnsConfig(): TableColumnConfig[] {
    let headerColumns = [];
    // console.warn('issat', this.isMastermssp);
    if (this.isMastermssp) {
      headerColumns = [{
        key: 'msspp',
        dataKey: 'msspp',
        title: String(this.$t('tenantMgmt.page.table.mssp')),
        sorter: true,
        width: this.adjustedColumns.hasOwnProperty('msspp') ? this.adjustedColumns['msspp'] : this.msspColumnConfig[0].width,
      }
      , {
        key: 'tenant',
        dataKey: 'tenant',
        title: String(this.$t('tenantMgmt.page.table.tenant')),
        sorter: true,
        width: 230,
        /* tslint:disable-next-line */
        render: (h: CreateElement, data: any): VNode => { // eslint-disable-line
          return (<div style="display: flex; align-items: center;">
            <div>{data.entry.tenant}</div>
            {data.entry.showTenantAddressWarning === 'YES' ?
              <SwIcon name="severity-minor" color="#f1c232" style={{ 'margin-left' : '10px', float: 'right' }}
              v-tooltip={{ compact: true, content: this.addressWarning, placement: 'bottom' }}></SwIcon> : <span style={{ margin : '10px', float: 'right' }}/>}
          </div>) as VNode;
        },
      }];
    } else {
      headerColumns = [{
        key: 'tenant',
        dataKey: 'tenant',
        title: String(this.$t('tenantMgmt.page.table.tenant')),
        sorter: true,
        width: 230,
        /* tslint:disable-next-line */
        render: (h: CreateElement, data: any): VNode => { // eslint-disable-line
          return (<div style="display: flex; align-items: center;">
            <div>{data.entry.tenant}</div>
            {data.entry.showTenantAddressWarning === 'YES' ?
              <SwIcon name="severity-minor" color="#f1c232" style={{ 'margin-left' : '10px', float: 'right' }}
              v-tooltip={{ compact: true, content: this.addressWarning, placement: 'bottom' }}></SwIcon> : <span style={{ margin : '10px', float: 'right' }}/>}
          </div>) as VNode;
        },
      }];
    }
    return headerColumns;
  }
  configKey: string = '';
  get columnConfig(): TableColumnConfig[] {
    let config = [];
    if (this.isMastermssp) {
      config = [
        {
          key: 'msspp',
          dataKey: 'msspp',
          title: String(this.$t('tenantMgmt.page.table.mssp')),
          sorter: false,
          width: 210,
        },
        {
          key: 'tenant',
          dataKey: 'tenant',
          title: String(this.$t('tenantMgmt.page.table.tenant')),
          sorter: false,
          width: 270,
        },
        {
          key: 'expand',
          type: 'expand',
          name: 'expand',
          className:(entry: any) => {
            return entry.multiple ? this.multipleStyling(entry)
            .concat(' iconTransform_collapse') : this.multipleStyling(entry)
            .concat(' iconTransform_expand');
          },
          /* tslint:disable-next-line */
          render: (h: CreateElement, data: any): VNode => {
            return (
              <div/>
            ) as VNode;
          },
        },
        {
          key: 'friendlyName',
          dataKey: 'friendlyName',
          title: String(this.$t('tenantMgmt.page.table.friendlyName')),
          sorter: true,
          width: 210,
          className:(entry: any) => {
            return this.multipleStyling(entry);
          },
          /* tslint:disable-next-line */
          render: (h: CreateElement, data: any): VNode => this.onFriendlyNameEdit(h, data),
        },
        {
          key: 'serNo',
          dataKey: 'serNo',
          title: String(this.$t('tenantMgmt.page.table.serNo')),
          sorter: (a: any, b: any) => {
            return a?.serNo - b?.serNo;
          },
          width: 120,
          className:(entry: any) => {
            return this.multipleStyling(entry);
          },
        },
        {
          key: 'productName',
          dataKey: 'productName',
          title: String(this.$t('tenantMgmt.page.table.product')),
          sorter: (a: any, b: any) => {
            return a?.product - b?.product;
          },
          width: 180,
          className:(entry: any) => {
            return this.multipleStyling(entry);
          },
          render: (h: CreateElement, data: any): VNode => this.prod(h, data),
          /* tslint:disable-next-line */
        }, {
          key: 'service',
          dataKey: 'service',
          title: String(this.$t('tenantMgmt.page.table.service')),
          sorter: (a: any, b: any) => {
            return a?.service - b?.service;
          },
          width: 140,
          className:(entry: any) => {
            return this.multipleStyling(entry);
          },
          render: (h: CreateElement, data: any): VNode => this.serv(h, data),
        }, {
          key: 'units',
          dataKey: 'units',
          title: String(this.$t('tenantMgmt.page.table.units')),
          tooltip: this.unitTooltipValue,
          sorter: (a: any, b: any) => {
            return a?.units > b?.units;
          },
          width: 120,
          className:(entry: any) => {
            return this.multipleStyling(entry);
          },
        },
        {
          key: 'usedNodeCount',
          dataKey: 'usedNodeCount',
          title: String(this.$t('tenantMgmt.page.table.usedNodeCount')),
          /* tslint:disable-next-line */
          // title: (h: CreateElement): VNode => {
          //   return (
          //     <div style={{ display:'flex', alignItems: 'center', whiteSpace: 'normal' }}>
          //       <span style={{ textAlign: 'center', marginRight: '0.25rem' }}>{ this.$t('tenantMgmt.page.table.usedNodeCount')
          //       .toString() }</span>
          //       <div style={{ cursor: 'pointer' }}>
          //         <SwIcon
          //           name="info"
          //           props-size={15}
          //           v-tooltip={this.usageTooltipValue}
          //         />
          //       </div>
          //     </div>
          //   ) as VNode;
          // },
          tooltip: this.usageTooltipValue,
          sorter: false,
          width: 130,
          className:(entry: any) => {
            return this.multipleStyling(entry);
          },
        },
        {
          key: 'firmware',
          dataKey: 'firmware',
          title: String(this.$t('tenantMgmt.page.table.firmware')),
          sorter: false,
          width: 120,
          className:(entry: any) => {
            return this.multipleStyling(entry);
          },
          render: (h: CreateElement, data: any): VNode => this.firm(h, data),
        },
        {
          key: 'startdate',
          dataKey: 'startdate',
          title: String(this.$t('tenantMgmt.page.table.startdate')),
          tooltip: this.registrationDateTooltip,
          sorter: false,
          width: 120,
          className:(entry: any) => {
            return this.multipleStyling(entry);
          },
        }, {
          key: 'expirydate',
          dataKey: 'expirydate',
          title: String(this.$t('tenantMgmt.page.table.expirydate')),
          sorter: false,
          width: 120,
          className:(entry: any) => {
            return this.multipleStyling(entry);
          },
          /* tslint:disable-next-line */
          render: (h: CreateElement, data: any): VNode => { // eslint-disable-line
            if (data.entry.expirydate !== 'Never' && data.entry.expirydate !== 'N/A' && data.entry.expirydate !== '') {
              // consreturnt datearray = data.entry.expirydate.split('/');
              // const newdate: any = datearray[1].concat('/', datearray[0], '/', datearray[2]);
              const now = (this.todayDate.slice(4, 6)).concat('/', this.todayDate.slice(6), '/', this.todayDate.slice(0, 4));
              const expiry: any = new Date(data.entry.expirydate);
              const today: any = new Date(now);
              const oneDay = 1000 * 60 * 60 * 24;
              const diffTime = expiry.getTime() - today.getTime();
              const diffDays = Math.round(diffTime / oneDay);
              if (diffDays < 0) {
                return (
                  <div class={'last_col_actions'}>
                  <div > {data.entry.expirydate}</div>
                <div class={'icon_dot code_red action-col-dot'} v-tooltip={{ compact: true, content: String(this.$t('tenantMgmt.page.tooltips.expired'))
                .concat((diffDays.toString()).substring(1), String(this.$t('tenantMgmt.page.tooltips.daysAgo'))) , placement: 'top' }}> </div>
                </div>
              ) as VNode;
              }
              if (diffDays > 0 && diffDays < 45) {
                return (
                  <div class={'last_col_actions'}>
                  <div>{data.entry.expirydate}</div>
                <div class={'icon_dot code_yellow action-col-dot'} v-tooltip={{ compact: true, content: String(this.$t('tenantMgmt.page.tooltips.expiring'))
                .concat(diffDays.toString(), String(this.$t('tenantMgmt.page.tooltips.days'))), placement: 'top' }}>
                </div>
                </div>
              ) as VNode;
              }
            }
            return <div> {data.entry.expirydate}</div> as VNode;
          },
        },
        {
          key: 'status',
          dataKey: 'status',
          title: String(this.$t('tenantMgmt.page.table.status')),
          sorter: (a: any, b: any) => {
            return a?.status - b?.status;
          },
          width: 120,
          className:(entry: any) => {
            return this.multipleStyling(entry);
          },
          /* tslint:disable-next-line */
          render: (h: CreateElement, data: any ): VNode => { // eslint-disable-line
            // let menu: boolean = false;
            const currStatus: string = data.entry.statusCode || '';
            if (currStatus === 'ACTIVE') {
              return (
                <div style={ { display: 'flex', alignItems: 'center' } }>
                  <div><SwStatusFlag icon-size={12} name="success"/></div>
                  <div style={ { marginLeft: '0.5rem' } }>{ data.entry.status }</div>
                </div>
              ) as VNode;
            }
            if (currStatus === 'PENDING') {
              return (
                <div style={ { display: 'flex', alignItems: 'center' } }>
                  <div><SwStatusFlag icon-size={12} name="inprogress"/></div>
                  <div style={ { marginLeft: '0.5rem' } }>{ data.entry.status }</div>
                </div>
              ) as VNode;
            }
            if (currStatus === 'EXPIRED') {
              return (
                <div style={ { display: 'flex', alignItems: 'center' } }>
                  <div><SwStatusFlag icon-size={12} name="minor"/></div>
                  <div style={ { marginLeft: '0.5rem' } }>{ data.entry.status }</div>
                </div>
              ) as VNode;
            }
            return (
              <div style={ { display: 'flex' } }>
                <div>{ data.entry.status }</div>
              </div>
            ) as VNode;
          },
        },
        {
          key: 'action',
          dataKey: 'action',
          title: String(this.$t('tenantMgmt.page.table.action')),
          // title: '',
          width: 98,
          className:(entry: any) => {
            return this.multipleStyling(entry);
          },
          /* tslint:disable-next-line */
          render: (h: CreateElement, data: any ): VNode => { // eslint-disable-line
            // let menu: boolean = false;
            if (data.entry.product) {
              return (
                <div class={[`${cssPrefix}__actions`]}>
                  <ContextMenu
                    menuItems={this.getMenuItems(data.entry)}
                    opened={this.configKey === data.entry._key}
                    cellKey={data.entry.product}
                    on-request-toggle={() => {
                      this.configKey = (this.configKey !== data.entry._key  ? data.entry._key : '');
                      this.friendlyNameEdit = ''; this.ifClicked = false;
                    }}
                    on-select={(itemId: any) => this.onSelectItem(itemId, data)}
                  />
                </div>
              ) as VNode;
            }
            return <div/> as VNode;
          },
        }];
    } else {
      config = [
        {
          key: 'tenant',
          dataKey: 'tenant',
          title: String(this.$t('tenantMgmt.page.table.tenant')),
          sorter: false,
          width: 270,
        },
        {
          key: 'expand',
          type: 'expand',
          id: 'expand',
          className:(entry: any) => {
            return entry.multiple ? this.multipleStyling(entry)
            .concat(' iconTransform_collapse') : this.multipleStyling(entry)
            .concat(' iconTransform_expand');
            // return this.multipleStyling(entry);
          },
          /* tslint:disable-next-line */
          render: (h: CreateElement, data: any): VNode => {
            return (
              <div/>
            ) as VNode;
          },
        },
        {
          key: 'friendlyName',
          dataKey: 'friendlyName',
          title: String(this.$t('tenantMgmt.page.table.friendlyName')),
          sorter: true,
          width: 210,
          className:(entry: any) => {
            return this.multipleStyling(entry);
          },
          /* tslint:disable-next-line */
          render: (h: CreateElement, data: any): VNode => this.onFriendlyNameEdit(h, data),
        },
        {
          key: 'serNo',
          dataKey: 'serNo',
          title: String(this.$t('tenantMgmt.page.table.serNo')),
          sorter: (a: any, b: any) => {
            return a?.serNo - b?.serNo;
          },
          width: 120,
          className:(entry: any) => {
            return this.multipleStyling(entry);
          },
        },
        {
          key: 'product',
          dataKey: 'product',
          title: String(this.$t('tenantMgmt.page.table.product')),
          sorter: (a: any, b: any) => {
            return a?.product - b?.product;
          },
          width: 120,
          className:(entry: any) => {
            return this.multipleStyling(entry);
          },
          render: (h: CreateElement, data: any): VNode => this.prod(h, data),
          /* tslint:disable-next-line */
        }, {
          key: 'service',
          dataKey: 'service',
          title: String(this.$t('tenantMgmt.page.table.service')),
          sorter: (a: any, b: any) => {
            return a?.service - b?.service;
          },
          width: 140,
          className:(entry: any) => {
            return this.multipleStyling(entry);
          },
          render: (h: CreateElement, data: any): VNode => this.serv(h, data),
        }, {
          key: 'units',
          dataKey: 'units',
          title: String(this.$t('tenantMgmt.page.table.units')),
          tooltip: this.unitTooltipValue,
          sorter: (a: any, b: any) => {
            return a?.units > b?.units;
          },
          width: 120,
          className:(entry: any) => {
            return this.multipleStyling(entry);
          },
        },
        {
          key: 'usedNodeCount',
          dataKey: 'usedNodeCount',
          title: String(this.$t('tenantMgmt.page.table.usedNodeCount')),
          /* tslint:disable-next-line */
          // title: (h: CreateElement): VNode => {
          //   return (
          //     <div style={{ display:'flex', alignItems: 'center', whiteSpace: 'normal' }}>
          //       <span style={{ textAlign: 'center', marginRight: '0.25rem' }}>{ this.$t('tenantMgmt.page.table.usedNodeCount')
          //       .toString() }</span>
          //       <div style={{ cursor: 'pointer' }}>
          //         <SwIcon
          //           name="info"
          //           props-size={15}
          //           v-tooltip={this.usageTooltipValue}
          //         />
          //       </div>
          //     </div>
          //   ) as VNode;
          // },
          tooltip: this.usageTooltipValue,
          sorter: false,
          width: 130,
          className:(entry: any) => {
            return this.multipleStyling(entry);
          },
        },
        {
          key: 'firmware',
          dataKey: 'firmware',
          title: String(this.$t('tenantMgmt.page.table.firmware')),
          sorter: false,
          width: 120,
          render: (h: CreateElement, data: any): VNode => this.firm(h, data),
          className:(entry: any) => {
            return this.multipleStyling(entry);
          },
        },
        {
          key: 'startdate',
          dataKey: 'startdate',
          title: String(this.$t('tenantMgmt.page.table.startdate')),
          tooltip: this.registrationDateTooltip,
          sorter: false,
          width: 120,
          className:(entry: any) => {
            return this.multipleStyling(entry);
          },
        }, {
          key: 'expirydate',
          dataKey: 'expirydate',
          title: String(this.$t('tenantMgmt.page.table.expirydate')),
          sorter: false,
          width: 120,
          className:(entry: any) => {
            return this.multipleStyling(entry);
          },
          /* tslint:disable-next-line */
          render: (h: CreateElement, data: any): VNode => { // eslint-disable-line
            if (data.entry.expirydate !== 'Never' && data.entry.expirydate !== 'N/A' && data.entry.expirydate !== '') {
              // const datearray = data.entry.expirydate.split('/');
              // const newdate: any = datearray[1].concat('/', datearray[0], '/', datearray[2]);
              const now = (this.todayDate.slice(4, 6)).concat('/', this.todayDate.slice(6), '/', this.todayDate.slice(0, 4));
              const expiry: any = new Date(data.entry.expirydate);
              const today: any = new Date(now);
              const oneDay = 1000 * 60 * 60 * 24;
              const diffTime = expiry.getTime() - today.getTime();
              const diffDays = Math.round(diffTime / oneDay);
              if (diffDays < 0) {
                return (
                  <div class={'last_col_actions'}>
                  <div > {data.entry.expirydate}</div>
                <div class={'icon_dot code_red action-col-dot'} v-tooltip={{ compact: true, content: String(this.$t('tenantMgmt.page.tooltips.expired'))
                .concat((diffDays.toString()).substring(1), String(this.$t('tenantMgmt.page.tooltips.daysAgo'))) , placement: 'top' }}> </div>
                </div>
              ) as VNode;
              }
              if (diffDays > 0 && diffDays < 45) {
                return (
                  <div class={'last_col_actions'}>
                  <div>{data.entry.expirydate}</div>
                <div class={'icon_dot code_yellow action-col-dot'} v-tooltip={{ compact: true, content: String(this.$t('tenantMgmt.page.tooltips.expiring'))
                .concat(diffDays.toString(), String(this.$t('tenantMgmt.page.tooltips.days'))), placement: 'top' }}>
                </div>
                </div>
              ) as VNode;
              }
            }
            return <div> {data.entry.expirydate}</div> as VNode;
          },
        },
        {
          key: 'status',
          dataKey: 'status',
          title: String(this.$t('tenantMgmt.page.table.status')),
          sorter: (a: any, b: any) => {
            return a?.status - b?.status;
          },
          width: 120,
          className:(entry: any) => {
            return this.multipleStyling(entry);
          },
          /* tslint:disable-next-line */
          render: (h: CreateElement, data: any ): VNode => { // eslint-disable-line
            // let menu: boolean = false;
            const currStatus: string = data.entry.statusCode || '';
            if (currStatus === 'ACTIVE') {
              return (
                <div style={ { display: 'flex', alignItems: 'center' } }>
                  <div><SwStatusFlag icon-size={12} name="success"/></div>
                  <div style={ { marginLeft: '0.5rem' } }>{ data.entry.status }</div>
                </div>
              ) as VNode;
            }
            if (currStatus === 'PENDING') {
              return (
                <div style={ { display: 'flex', alignItems: 'center' } }>
                  <div><SwStatusFlag icon-size={12} name="inprogress"/></div>
                  <div style={ { marginLeft: '0.5rem' } }>{ data.entry.status }</div>
                </div>
              ) as VNode;
            }
            if (currStatus === 'EXPIRED') {
              return (
                <div style={ { display: 'flex', alignItems: 'center' } }>
                  <div><SwStatusFlag icon-size={12} name="minor"/></div>
                  <div style={ { marginLeft: '0.5rem' } }>{ data.entry.status }</div>
                </div>
              ) as VNode;
            }
            return (
              <div style={ { display: 'flex' } }>
                <div>{ data.entry.status }</div>
              </div>
            ) as VNode;
          },
        },
        {
          key: 'action',
          dataKey: 'action',
          title: String(this.$t('tenantMgmt.page.table.action')),
          // title: '',
          width: 98,
          className:(entry: any) => {
            return this.multipleStyling(entry);
          },
          /* tslint:disable-next-line */
          render: (h: CreateElement, data: any ): VNode => { // eslint-disable-line
            // let menu: boolean = false;
            if (data.entry.product) {
              return (
                <div>
                  <ContextMenu
                    menuItems={this.getMenuItems(data.entry)}
                    opened={this.configKey === data.entry._key}
                    cellKey={data.entry.product}
                    on-request-toggle={() => {
                      this.configKey = (this.configKey !== data.entry._key  ? data.entry._key : '');
                      this.friendlyNameEdit = ''; this.ifClicked = false;
                    }}
                    on-select={(itemId: any) => this.onSelectItem(itemId, data)}
                  />
                </div>
              ) as VNode;
            }
            return <div/> as VNode;
          },
        }];
    }
    return (config) as TableColumnConfig[];
  }
  multipleStyling(entry: any) {
    const style = entry._expandable && entry.highlight && !entry.multiple ? 'rowTopBorder' : entry.highlight && entry.lastEntry && !entry.multiple ? 'rowBottomBorder' :
              entry.highlight && !entry._expandable && !entry.lastEntry && !entry.multiple ? 'tableRowSelection' : '';
    return style;
  }
  onMoveOut() {
    this.configKey = '';
    this.friendlyNameEdit = '';
    this.ifClicked = false;
  }
  /* tslint:disable-next-line */
  hover(h: CreateElement, data: any) {
    return (
            <SwIconButton name="tenant"  icon="pencil" nativeOn-click={() => {
              this.enableTenantFormModal = true;
              this.tenantModalMode = 'edit';
              this.msspType = 'select';
              const tenantObject = {
                msspName: data.entry.msspp,
                tenantName: data.entry.tenant,
                contactName: '',
                companyName: '',
                emailAddress: '',
                phoneNumber: '',
                streetAddress: '',
                cityName: '',
                countryName: '',
                stateName: '',
                zipCode: '',
                additionalMessage: '',
              };
              this.$store.commit('TenantManagementStoreModule/setNewTenantModalObject', { newTenantModalObject: tenantObject });
            }}
            >
            Tenant
            </SwIconButton>
          ) as VNode;
  }
  get unitTooltipValue(): TooltipDirValues {
    return {
      enabled: true,
      placement: 'bottom',
      content: String(this.$t('tenantMgmt.page.tooltips.unit')),
      includePopperForHover: true,
    };
  }
  get usageTooltipValue(): TooltipDirValues {
    return {
      enabled: true,
      placement: 'bottom',
      content: String(this.$t('tenantMgmt.page.tooltips.usage')),
      includePopperForHover: true,
    };
  }
  get registrationDateTooltip(): TooltipDirValues {
    return {
      enabled: true,
      placement: 'bottom',
      content: String(this.$t('tenantMgmt.page.tooltips.reg')),
      includePopperForHover: true,
    };
  }
  onConsoleClick(data: any) {
    this.$store.commit('startLoading');
    let prod : any = [];
    this.filteredData.map((ele: any) =>  {
      ele.entries.map((ind:any) => {
        if (ind._key === (data._key)) {
          prod = ele;
        }
      });
    });
    const datatoPost = {
      tenantId: prod.tenantId,
      tileName:'ISMSWSAFEENABLED',
    };
    MswApiService.tenant.console(datatoPost)
    .then((resp: any) =>  {
      if (resp.operationStatus === 'NOK') {
        this.$store.commit('stopLoading');
        const message: any = { infoType: 'high', infoMsg: resp.msgDesc };
        this.$store.commit('enqueueMessage', message);
      } else {
        this.$store.commit('stopLoading');
        // const message: any = { infoType: 'success', infoMsg: resp.msgDesc };
        // this.$store.commit('enqueueMessage', message);
        const urlToOpen = `${envCongif.spog_url}/muir/spog/login?code=${resp.content.accessCode}${data.consoleIconUrl}`;
        window.open(urlToOpen);
      }
      this.$store.commit('stopLoading');
      this.$emit('closeUserModal');
    })
    .catch((error: any) => {
      this.$store.commit('stopLoading');
      const message: any = { infoType: 'high', infoMsg: error.msgDesc };
      this.$store.commit('enqueueMessage', message);
    });
  }
  /* tslint:disable-next-line */
  prod(h:CreateElement, data: any): VNode {
    return (
        <div class="friendlyname_col_text_field ">
        <span class="friendlyname_col_textElip"
          v-tooltip={{ enabled: data.entry.product.length  > 30 ? true : false, compact: true, content: data.entry.product, placement: 'bottom' }}
          >{data.entry.productName}
          </span>
        </div>
      ) as VNode;
  }
  /* tslint:disable-next-line */
  serv(h:CreateElement, data: any): VNode {
    return (
        <div class="friendlyname_col_text_field ">
        <span class="friendlyname_col_textElip"
          v-tooltip={{ enabled: data.entry.service.length  > 35 ? true : false, compact: true, content: data.entry.service, placement: 'bottom' }}
          >{data.entry.service}
          </span>
        </div>
      ) as VNode;
  }
  /* tslint:disable-next-line */
  firm(h:CreateElement, data: any): VNode {
    return (
        <div class="friendlyname_col_text_field ">
        <span class="friendlyname_col_textElip"
          v-tooltip={{ enabled: data.entry.firmware.length  > 50 ? true : false, compact: true, content: data.entry.firmware, placement: 'bottom' }}
          >{data.entry.firmware}
          </span>
        </div>
      ) as VNode;
  }
  /* tslint:disable-next-line */
  onFriendlyNameEdit(h:CreateElement, data: any): VNode {
    return (
        <div class="friendlyname_col_text_field ">
          {!this.ifClicked ?
        <div class="friendlyname_col_text"
          on-mouseover={() => !this.ifClicked  ? this.friendlyNameEdit =  data.entry._key : '' }
          v-tooltip={{ enabled: data.entry.friendlyName.length  > 20 ? true : false, compact: true, content: data.entry.friendlyName, placement: 'bottom' }}
          >
          {this.ifClicked && this.friendlyNameEdit ===  data.entry._key ? '' : data.entry.friendlyName}
          </div> : <div on-mouseover={() => !this.ifClicked  ? this.friendlyNameEdit =  data.entry._key : '' }
          v-tooltip={{ enabled: data.entry.friendlyName.length  > 20 ? true : false, compact: true, content: data.entry.friendlyName, placement: 'bottom' }}
          >
          {this.ifClicked && this.friendlyNameEdit ===  data.entry._key ? '' : data.entry.friendlyName}
          </div>}
            <div> {this.friendlyNameEdit === data.entry._key && data.entry.showRename && !this.ifClicked ?
          <SwIconButton name="tenant"  icon="pencil" class="friendlyname_col_pencilIcon"
          nativeOn-click={  () => {
            this.configKey = '';
            this.fName = data.entry.friendlyName;
            this.ifClicked = true;
          }} v-tooltip={{ compact: true, content: String(this.$t('tenantMgmt.page.tooltips.editFriend')), placement: 'bottom' }}
            >
            </SwIconButton>  : <span/>
          }</div>
          <div>{ this.ifClicked &&  this.friendlyNameEdit === data.entry._key && data.entry.showRename ?
          <div class={'last_col_actions'}>
        <SwTextfield class={'editText'} props-name ={ 'friendlyName' }  props-value={ (data.entry.friendlyName) }
        on-input={(e:any) =>
                { if (e.length <= 50) data.entry.friendlyName = e; }
              }>
        </SwTextfield>
        <SwIcon class="friendlyname_col_true_icon" props-size={14} name="checkmark" color="#99CC00"
              nativeOn-click={() => {
                if (data.entry.friendlyName.trim().length > 0) {
                  this.renameProduct(data);
                  this.ifClicked = false;
                  // this.editFriendlyName(data, false);
                }
              }
            }></SwIcon>
            <span  style="borderRight:1px solid #C6D1DE">&nbsp;</span>
            <SwIcon class="friendlyname_col_true_icon" props-size={12} name="close" color="#ff0000"
              nativeOn-click={() => {
                this.ifClicked = false;
                data.entry.friendlyName = this.fName;
                // this.editFriendlyName(data, false);
              }
            }></SwIcon> </div> : <div/>
          } </div>
        </div>
      ) as VNode;
  }
  renameProduct(data: any) {
    this.$store.commit('startLoading');
    const renamelist = [{ serialNumber: data.entry.serNo, newName: data.entry.friendlyName }];
    this.$store.dispatch(
      'MswProductsStoreModule/renameFriendlyName', { prodsRenamelist: renamelist },
    )
    .then((res) => {
      if (res.msgCode === 'MSWAPP:PRODSRENAMESUCCESS') {
        const message: InfoState = { infoType: 'success', infoMsg: res.msgDesc };
        this.$store.commit('enqueueMessage', message);
        this.getTenantMgmtData();
      } else if (res.msgCode === 'MSWAPP:PRODSRENAMEFAILURE') {
        const message: InfoState = { infoType: 'high', infoMsg: res.msgDesc };
        this.$store.commit('enqueueMessage', message);
        data.entry.friendlyName = this.fName;
      } else {
        const message: InfoState = { infoType: 'high', infoMsg: String(this.$t('tenantMgmt.page.messages.rename')) };
        this.$store.commit('enqueueMessage', message);
        data.entry.friendlyName = this.fName;
      }
      this.$store.commit('stopLoading');
    });
  }
  onProductEdit(data: any) {
    // // console.warn(data);
    this.selProductRegion = data?.region || '';
    this.enableProductModal = !this.enableProductModal;
    this.msspFiltered = true;
    this.tenantFiltered = true;
    this.showRename = data.showRename;
    let prod : any = [];
    let entry : any = {};
    this.formatTableData()
    .map((ele: any) =>  {
      ele.entries.map((ind:any) => {
        if (ind._key === (data._key)) {
          prod = ele;
          entry = ind;
        }
      });
    });
    // this.msspPrefilter.MSSPs.map((obj:any) => {
    //   if (obj.MSSPName === prod.msspp) {
    //     obj.Tenants.map((ele:any) => {
    //       if (ele.TenantName === prod.tenant) {
    //         prod.tenantId = ele.TenantID;
    //       }
    //     });
    //   }
    // });
    // // console.warn('prod', prod);
    this.$store.commit('TenantManagementStoreModule/setTzProvision', { tzProvision: false });
    this.$emit('onAccept', {}, false);
    const product = {
      MSSPname: prod.msspp,
      MsspId: prod.msspId,
      tenantName: prod.tenant,
      tenantId: prod.tenantId,
      accessScopeMessage: '',
      authCode: '',
      serialNumber: data.serNo,
      friendlyName: data.friendlyName,
      performFurtherValidation: false,
      isdefaultgroupAssignedtoTenant: false,
      // serviceName: data.service,
      productDetails: [{
        productName: data.product,
        productId: data. productId,
        serviceName: entry.service,
        unitSelected: entry.units === 'No upper limit' ? 'noUpperLimit' : entry.units,
        expiryType: entry.expirydate,
        regionSelected: data.region || '',
        platform: data.platform || '',
        friendlyName: data.friendlyName,
        serviceId: data.serviceID || '',
        showHA: data.isHA,
      }],
    };
    this.$store.commit('TenantManagementStoreModule/setNewProductModalObject', { newProductModalObject: product });
    // this.setNewProductModalObject({ newProductModalObject: {
    //   MSSPname: prod.msspp,
    //   MsspId: prod.msspId,
    //   tenantName: prod.tenant,
    //   tenantId: prod.tenantId,
    //   accessScopeMessage: '',
    //   authCode: '',tableData
    //   serialNumber: data.serNo,
    //   friendlyName: data.friendlyName,tableData
    //   performFurtherValidation: false,
    //   isdefaultgroupAssignedtoTenant: false,
    //   // serviceName: data.service,
    //   productDetails: [{
    //     productName: data.product,
    //     productId: data. productId,
    //     serviceName: data.service,
    //     unitSelected: data.units === 'No upper limit' ? 'noUpperLimit' : data.units,
    //     expiryType: data.expirydate,
    //     regionSelected: data.region || '',
    //     platform: data.platform || '',
    //     serviceId: data.serviceID || '',
    //     showHA: data.isHA,
    //   }],
    // }});
  }
  /* tslint:disable-next-line */
  get isMasterMssp() {
    const roles = JSON.parse(this.$store.getters.getUserInfo).user.roles || [];
    return roles.indexOf('MASTERMSSP') > -1 ? true : false;
  }
  async created() {
    // (window as any).pendo.initialize();
    await this.getTenantMgmtData();
    // // console.warn(this.msspPrefilter);
    // await this.setMultiple();
    if (this.msspPrefilter.showPendo && this.msspPrefilter.showPendo === 'YES') {
      this.showPendoConsentModal = true;
    }
    this.doCall = false;
    this.setHelpId(this.isMasterMssp ? 'master-mssp' : 'regular-mssp');
  }
  startPendoAnalytics() {
    const currentUser : any = localStorage.getItem(currentUserKey);
    const userDetails = JSON.parse(currentUser) || '';
    if (userDetails !== '') {
      (window as any).pendo.initialize({
        visitor: {
          id: userDetails.userId || '',
          username: userDetails.userId || '', // For SFDC integ //
          org:  this.msspPrefilter.orgName || '', // email domain //
          mssp: this.msspPrefilter.MSSPTier || '', // MSSP tier //
        },
        account: {
          id: this.msspPrefilter.orgID || '',  // OrgId for Company//
          name: this.msspPrefilter.orgName || '', // Org Name
        },
      });
    }
  }
  setHelpId(value:string) {
    const temp:string[] = [];
    temp.push(value);
    this.setHelpContentId({ helpId:temp });
    window.parent.postMessage({ route: 'mssp-tenant-mgmt', helpId: temp }, '*');
  }
  updated() {
    this.setHelpId(this.isMasterMssp ? 'master-mssp' : 'regular-mssp');
  }
  destroyed() {
    this.setHelpId('default');
    // window.parent.removeEventListener('storage', () => {});
  }
  refresh() {
    this.$store.commit('startLoading');
    this.refreshClicked = true;
    this.mssp = this.isLargeCustomer ? this.mssp : this.msspSelected;
    this.tenant = this.isLargeCustomer ? this.tenant : this.tenantSelected;
    // console.warn('te4', this.isLargeCustomer, this.tenant);
    this.getTenantMgmtData();
    this.searchText = '';
  }
  defaultSelection() {
    this.msspPrefilter.MSSPs && this.msspPrefilter.MSSPs.map((mssp:any) => {
      if (mssp.hasOwnProperty('Tenants')) {
        mssp.Tenants.map((tenant:any) => {
          this.tenant = this.isLargeCustomer && tenant.isDefault === 'YES' ? tenant.productGroupId.toString() : this.tenant;
          this.mssp = this.isLargeCustomer && tenant.isDefault === 'YES' ? mssp.MSSPID.toString() : this.mssp;
          this.defaultmssp = this.mssp;
          this.defaultTenant = this.tenant;
        });
      }
    });
  }
  async getTenantMgmtData(enableLoading: boolean = true) {
    try {
      this.loaded = true;
      await this.getSelectedColumnList();
      enableLoading && this.visible;
      this.$store.commit('startLoading');
      // console.warn('step1');
      await this.getCustomersList();
      // console.warn('step2');
      await this.getMsspPrefiter();
      // console.warn('step3');
      await this.getPreferenceData();
      // console.warn('step4');
      await this.getMsspProductDetails();
      // console.warn('step5');
      // this.preFilter();
      setTimeout(() => {
        // this.visible = false;
        this.$store.commit('stopLoading');
      }, 4000); // tslint:disable-line
    } catch {
      if (enableLoading) { this.$store.commit('stopLoading'); }
    }
  }
  async getMsspProductDetails() {
    const dta = {
      pageno : 1,
      pagesize: 10000,
      msspids : 'All',
      serialNumber : '',
      productLine: '',
      friendlyName : '',
      firmwareVersion: '' ,
      isForced : 'YES',
      nonMSSPTenant: true,
      tenantid: this.isLargeCustomer ? this.tenant : '',
    };
    return new Promise((res) => {
      productListCache.getproductListsData(dta, this.doCall)
      // MswApiService.tenant.getMsspProductDetails(dta)
      .then((resp: any) => {
        // console.warn('prodServicesstart', resp);
        this.msspProducts = resp.content;
        this.msspStat = resp.content;
        this.tableData = this.formatTableData();
        this.data = this.tableData;
        // console.warn('da4', this.data);
        this.filteredData = this.tableData;
        this.filterOptionsData = this.tableData;
        this.infiniteTableData = this.filteredData;
        this.todayDate = resp.content.Datenow;
        this.addressWarning = resp.content.AddressWarningMsg;
        // console.warn(`Tenant Address warning text is: ${this.addressWarning}`);
        this.loaded = false;
        this.tableData.map((obj:any) => {
        // const entry: any[] = [];
          if (obj.entries.length > 1) {
            obj.entries.map((ele: any) => {
              if (ele._expandable && !this.collapsed.includes(ele._key)) {
                this.needtoBeExpanded.push(ele._key);
              }
            });
          }
        });
        if (!this.isLargeCustomer) {
          this.preFilter();
        }
        this.filterStatusForTableData();
        // console.warn(this.visible);
        // if (!this.visible) {
        //   console.warn('inside not visible condition');
        //   this.preFilter();
        // }
        setTimeout(() => {
          this.visible = false;
          const expandElements: any = (document.getElementsByClassName('sw-table-row__cell sw-table-row__cell--typed-col rowTopBorder sw-flexbox sw-flexbox__flex-none'));
          // console.warn('ex', expandElements);
          for (const items of expandElements) {
            // console.warn('expa', items.dispatchEvent(new Event('click')));
            items.click();
            // items.addEventListener('click', this.onEntryExpanding, false);
          }
          // console.warn('onclick', expandElements);
        }, 3000); // tslint:disable-line
        // this.$store.commit('stopLoading');
        res(true);
      })
      .catch(() => {
        res(true);
        setTimeout(() => {
          this.visible = false;
        }, 3000); // tslint:disable-line
        this.$store.commit('stopLoading');
        // console.warn('prodServicesEnd');
      });
    });
  }
  async getMsspPrefiter() {
    return new Promise((res, rej) => {
      MswApiService.tenant.getMsspPrefilter(this.refreshClicked, true, true)
      .then((resp: any) => {
        // console.warn('prefilterStart', resp);
        this.refreshClicked = false;
        this.msspPrefilter = resp.content;
        this.msspPrefilterData = resp;
        this.isLargeCustomer = resp.content.IsLargeCustomer === 'YES' ? true : false;
        this.defaultSelection();
        this.$store.commit('TenantManagementStoreModule/setPrefilterObject', { prefilterObject: resp });
        Object.assign(this.provisionObj, {
          provisionMSSP: resp.content.ProvisionMSSP || '',
          provisionTenant: resp.content.ProvisionTenant || '',
          provisionProduct: resp.content.ProvisionProduct || '',
          provisionTenantMsg: resp.content.ProvisionTenantMsg || '',
          provisionProductMsg: resp.content.ProvisionProductMsg || '',
          showAccessManagement: resp.content.showAccessManagement || '',
        });
        this.isMastermssp = resp.content.ProvisionMSSP === 'YES' ? true : false;
        // console.warn(this.msspPrefilter, 'this.msspPre');
        if (this.msspPrefilter.pendoEnabled && this.msspPrefilter.pendoEnabled === 'YES' &&
            this.msspPrefilter.showPendo && this.msspPrefilter.showPendo !== 'YES') {
          this.startPendoAnalytics();
        }
        // console.warn('prefilterEnd');
        const service:any = [];
        this.msspPrefilter.Products.map((obj:any) => {
          if (obj.Services) {
            obj.Services.map((obj1: any) => {
              service.push(obj1.ServiceName);
              return obj1.ServiceName;
            });
          }
        });
        const wholeService: any = [];
        service.map((obj:any) => {
          if (this.services.indexOf(obj) === -1) {
            wholeService.push(obj);
          }
        });
        this.services = wholeService;
        // console.warn('prefilterEnd1');
        res(resp);
      })
      .catch(() => {
        this.$store.commit('stopLoading');
        rej(false);
      });
    });
  }
  setMultiple() {
    let itemObj: any = [];
    const expand : any = this.needtoBeExpanded;
    // console.warn('mul', this.needtoBeExpanded, this.collapsed);
    itemObj = this.filteredData.map((obj:any) => {
      // console.warn('filterData', obj);
      const entries: any = [];
      for (let i = 0; i < obj.entries.length && obj.entries.length > 0; i = i + 1) {
        const expandableEntry =  (obj.entries.filter((ele: any) => ele.serNo === obj.entries[i].serNo))[0];
        const isExpandable = obj.entries[i]._expandable && (obj.entries.filter((ele: any) => ele.serNo === obj.entries[i].serNo)).length === 1 && obj.entries[i].multiple
         || !expand.includes(obj.entries[i]._key) && this.collapsed.some((ele: any) => ele.includes(obj.entries[i]._key.slice(0, -1)));
        if (i < obj.entries.length - 1) {
          // console.warn('mul', isExpandable, expandableEntry);
          if (isExpandable) {
            obj.entries[i].service = 'Multiple';
            obj.entries[i].units = 'Multiple';
            obj.entries[i].expirydate = 'Multiple';
            obj.entries[i].startdate = 'Multiple';
            obj.entries[i].firmware = 'Multiple';
            obj.entries[i].usedNodeCount = 'Multiple';
            obj.entries[i].status = 'Multiple';
            obj.entries[i].multiple = true;
          }
        }
        // console.warn('key', obj.entries[i].friendlyName);
        if (i < obj.entries.length - 1 && i > 0) {
          obj.entries[i]._expandable = obj.entries[i].serNo === obj.entries[i + 1].serNo &&
          obj.entries[i].serNo !== obj.entries[i - 1].serNo || obj.entries[i].multiple ? true : false;
          obj.entries[i].highlight = obj.entries[i].serNo === obj.entries[i + 1].serNo ||
          obj.entries[i].serNo === obj.entries[i - 1].serNo ? true : false;
          obj.entries[i].lastEntry = obj.entries[i].serNo !== obj.entries[i + 1].serNo &&
          obj.entries[i].serNo === obj.entries[i - 1].serNo ? true : false;
          if ((obj.entries[i].serNo === obj.entries[i - 1].serNo && !expandableEntry?.multiple) || obj.entries[i].serNo !== obj.entries[i - 1].serNo) {
            entries.push(obj.entries[i]);
          }
        } else {
          if (i === obj.entries.length - 1 && i !== 0) {
            obj.entries[i]._expandable =  obj.entries[i].multiple ? true : false;
            obj.entries[i].highlight = obj.entries[i].serNo === obj.entries[i - 1].serNo ? true : false;
            obj.entries[i].lastEntry = obj.entries[i].serNo === obj.entries[i - 1].serNo ? true : false;
            if (!expandableEntry?.multiple && (obj.entries[i].serNo === obj.entries[i - 1].serNo) || obj.entries[i].serNo !== obj.entries[i - 1].serNo) {
              entries.push(obj.entries[i]);
            }
          } else if (i === 0 && i !== obj.entries.length - 1) {
            obj.entries[i]._expandable =  (obj.entries[i].serNo === obj.entries[i + 1].serNo || obj.entries[i].multiple) ? true : false;
            obj.entries[i].highlight = obj.entries[i].serNo === obj.entries[i + 1].serNo ? true : false;
            obj.entries[i].lastEntry = false;
            entries.push(obj.entries[i]);
          } else if (i === 0 && i === obj.entries.length - 1) {
            obj.entries[i]._expandable = obj.entries[i].multiple ? true : false;
            obj.entries[i].highlight = false;
            entries.push(obj.entries[i]);
          } else {
            entries.push(obj.entries[i]);
          }
        }
        if (!obj.entries[i].multiple && obj.entries[i]._expandable) {
          if (!expand.includes(obj.entries[i]._key)) {
            expand.push(obj.entries[i]._key);
          }
        }
        // console.warn('expand', expand);
        if (obj.entries.length - 1 !== 0) {
          // const n = i === 0 ? i + 1 : i === obj.entries.length - 1 ? i - 1 : i + 1;
          if ((obj.entries[i]._expandable && obj.entries[i].multiple) || (!obj.entries[i]._expandable && obj.entries[i].highlight)) {
            const index = this.needtoBeExpanded.indexOf(obj.entries[i]._key);
            if (index !== -1) {
              // console.warn('ex', expand);
              expand.splice(index, 1);
              console.warn('ex1', expand);
            }
            // console.warn('inentry', this.needtoBeExpanded, index);
          }
          // console.warn('expand1', expand);
        }
        // console.warn('flags', obj.entries[i]._key, obj.entries[i]._expandable, obj.entries[i].lastEntry, this.needtoBeExpanded);
        // this.onEntryExpanding({ entryKey: obj.entries[i]._key, expanding: true });
      }
      // console.warn('entries', this.needtoBeExpanded);
      obj.entries = entries;
      // console.warn('objEntr', obj.entries);
      // console.warn('itemObj', obj);
      return obj;
    });
    // console.warn('itemObj1', itemObj);
    this.filteredData = itemObj;
    this.infiniteTableData = this.filteredData;
        // console.warn('sheek', this.filteredData, this.infiniteTableData);
  }
  uniq(data: any) {
    const seen:any = {};
    return data.filter((item: any) => {
      return seen.hasOwnProperty(item) ? false : (seen[item] = true);
    });
  }
  async getCustomersList() {
    this.customersList = [];
    // if (this.$store.getters.isLargeCustomer) {
    //   this.$store.commit('startLoading');
    //   const forceFetch = true;
    //   const isFromMssp = true;
    //   this.$store.dispatch('DashBoardStoreModule/populateCustomerWidgets', { forceFetch, isFromMssp })
    //   .then((res: any) => {
    //     this.$store.commit('stopLoading');
    //     if (res.prodGroupLicenseStatus) {
    //       res.prodGroupLicenseStatus.forEach((element : any)  => {
    //         if (element.msspId) {
    //           this.customersList.push({ productGroupName: element.productGroupName, productGroupId: element.productGroupId });
    //         }
    //       });
    //       this.fullCustomerist = this.customersList;
    //       this.$emit('customerListEmitter', res.prodGroupLicenseStatus);
    //     }
    //   });
    // } else {
    this.$store.dispatch('MswProductsStoreModule/getCustomerName', 'tenantMgmt')
    .then((res) => {
      // this.$store.commit('stopLoading');
      this.fullCustomerist = [];
      if (res.productGroup) {
        res.productGroup.forEach((element : any)  => {
          if (element.msspId && element.addressId !== '') {
            this.customersList.push({ productGroupName: element.productGroupName, productGroupId: element.productGroupId });
          }
        });
        this.fullCustomerist = this.customersList;
        this.$emit('customerListEmitter', res.productGroup);
      }
    });
    // }
  }
  formatTableData() {
    let tableData: TableEntryGroup[] = [];
    // console.warn('formatDatastart');
    this.msspProducts.mssplist && this.msspProducts.mssplist.map((element: any, index: any) => {
      // console.warn('element', element, element.tenantName);
      const elemObj: any = {
        key: `${index}`,
        // tslint:disable-next-line
        label: (h: CreateElement): VNode => {
          const tableData: TableEntry[] = [{
            _key: element.id,
            msspp: element.msspName,
            tenant: element.tenantName,
            msspId: element.msspId,
            tenantId: element.tenantId,
            editTenant: element.editTenant,
            editMSSP: element.editMSSP,
            showTenantAddressWarning: element.showTenantAddressWarning,
            FilterGrpId: element.FilterGrpId,
          }];
          return (
            <div class={['sw-flexbox']}>
            <SwTable
                class={['sw-flexbox__flex']}
                show-header={false}
                no-background={true}
                columns-config={ this.headerColumnsConfig }
                get-float-actions={this.getFloatActions}
                table-data={ tableData }
                click-row-to-select={false}
              />
            </div>
          ) as VNode;
        },
        msspp: element.msspName,
        tenant: element.tenantName,
        editTenant: element.editTenant,
        editMSSP: element.editMSSP,
        entries: [],
        tenantId: element.tenantId,
        msspId: element.msspId,
        showTenantAddressWarning: element.showTenantAddressWarning,
        FilterGrpId: element.FilterGrpId,
      };
      if (element.serialList) {
        element.serialList.map((item: any, indexItem: any) => {
          // console.warn('friend', item.friendlyName);
          item.serviceList.map((item1: any, indexItem2: any, arr: any) => {
            const itemObj: TableEntry = {
              _key: `${element.id}.${indexItem}.${indexItem2}`,
              _expandable: arr.length > 1 && indexItem2 === 0 ? true : false,
              highlight: arr.length > 1 ? true : false,
              lastEntry: arr.length - 1 === indexItem2 ? true : false,
              multiple: false,
              product: item.Product || '',
              productName: item.ProductName || '',
              productId: item.productID || '',
              serNo: item.serialNumber || '',
              friendlyName: item.friendlyName || '',
              isHA: item.isHA === 'YES' ? true : false,
              firmware: item.firmwareVersion || '',
              service: item1.serviceName || '',
              serviceID: item1.serviceID || '',
              units: item1.nodeCount || '',
              status: item1.msspStatusText || '',
              statusCode: item1.msspStatus || '',
              showRename: item.showRename === 'YES' ? true : false,
              dtExpiryDate: item1.dtExpiryDate || '',
              expirydate: item1.expiryDate || '',
              dtStartDate: item1.dtStartDate || '',
              startdate: item1.StartDate || '',
              editAllowed: item1.editAllowed,
              transferAllowed: item1.transferAllowed,
              deleteAllowed: item1.deleteAllowed,
              removeMsspMonthlyAllowed: item1.removeMsspMonthlyAllowed,
              showDownloadCSV: item1.showDownloadCSV,
              showConsoleIcon: item1.showConsoleIcon,
              consoleIconUrl: item1.consoleIconUrl,
              platform: item.platform,
              region: item1.region,
              usedNodeCount: item1.usedNodeCount,
            };
            elemObj.entries.push(itemObj);
            // console.warn('elemObj', elemObj.entries, itemObj);
            // if (itemObj._expandable) {
            //   this.needtoBeExpanded.push(itemObj._key);
            // }
          });
        });
      }
      // this.sortGroups(elemObj);
      tableData = [...tableData, ...[elemObj]];
    });
    // const duplicate = tableData.map((obj:any) => obj.msspp);
    // const ifDuplicate = new Set(duplicate);
    // if (ifDuplicate.size === 1) {
    //   const remove = this.selectedColumnKeys.indexOf('msspp');
    //   this.selectedColumnKeys.splice(remove, 1);
    // }
    // console.warn('formatData', tableData);
    // tableData.map((obj:any) => {
    //   // const entry: any[] = [];
    //   if (obj.entries.length > 1) {
    //     obj.entries.map((ele: any) => {
    //       if (ele._expandable) {
    //         // tslint:disable-next-line
    //         const expandElements: any = Array.from(document.getElementsByClassName('sw-table-row__cell sw-table-row__cell--typed-col rowTopBorder sw-flexbox sw-flexbox__flex-none'));
    //         console.warn('ex', expandElements);
    //         for (const items of expandElements) {
    //           console.warn('expa', items);
    //           // items.click();
    //         }
    //         console.warn('onclick', expandElements);
    //         // this.onEntryExpanding({ entryKey : ele._key, expanding: false });
    //         // this.onEntryExpanding({ entryKey : ele._key, expanding: true });
    //       }
    //     });
    //   }
    // });
    return tableData;
  }
  private sortGroups() {
    this.filteredData.forEach((group: any) => {
      if (group.entries.length !== 0) {
        group.entries.sort(this.columnSorter);
        if (!this.sortedColumns.ascending) {
          group.entries.reverse();
        }
      }
    });
  }
  async getPreferenceData() {
    return new Promise((res: any) => {
      MswApiService.tenant.getMsspPreferenceFilter()
      .then((resp: any) => {
        // console.warn('userPreferencestart', resp);
        const extractJsonInfo: any = JSON.parse(resp.preferenceData);
        const mssp: any = this.msspOptions.find((obj: any) => obj.id === extractJsonInfo.msspSelected);
        this.mssp = this.msspOptions.length > 2 && extractJsonInfo.msspSelected !== '' ? mssp.id : this.mssp; // assigning this.mssp again when there is one mssp
        const tenant: any = this.tenantOptions.find((obj: any) => obj.id === extractJsonInfo.tenantSelected);
        this.tenant = extractJsonInfo.tenantSelected !== '' ? tenant.id : this.isLargeCustomer ? this.tenant : this.tenantSelected;
        this.msspFiltered = (this.mssp === '-1' || this.mssp === '-2') ? false : true;
        this.tenantFiltered = (this.tenant === '-1' || this.tenant === '-2') ? false : true;
        this.selectedProduct = extractJsonInfo.productSelected;
        this.selectedService = extractJsonInfo.serviceSelected;
        this.min = extractJsonInfo.min !== '' ? extractJsonInfo.min : '0';
        this.max = extractJsonInfo.max !== '' ? extractJsonInfo.max : '99999';
        this.startdate = extractJsonInfo.startdate;
        this.expirydate = extractJsonInfo.expirydate;
        if (extractJsonInfo.hasOwnProperty('selectedColumns')) {
          for (const item of extractJsonInfo.selectedColumns) {
            // console.warn('it', typeof (item));
            if (typeof (item) === 'object') {
              this.selectedColumnKeys.splice(this.selectedColumnKeys.indexOf(item), 1);
            }
            if (!this.selectedColumnKeys.includes(item)) {
              // console.warn('rt', item);
              if (typeof (item) !== 'object') {
                this.selectedColumnKeys.push(item);
              }
            }
          }
        }
        // console.warn('sel3', this.selectedColumnKeys);
        this.status = extractJsonInfo.statusSelected || this.status;
        if (this.startdate !== '') {
          this.selectedColumnKeys.push('startdate');
        }
        if (this.selectedColumnKeys.includes('product') || this.selectedColumnKeys.includes('startdate')) {
          this.ifColumnSelected = true;
        }
        // this.preFilter();
        this.onProductSelect(true);
        // console.warn('userPreferenceend');
        res(true);
      })
      .catch(() => {
        res(true);
        this.$store.commit('stopLoading');
      });
    });
  }
  preFilter() {
    // console.warn('inside prfilter mthd');
    this.onMsspChange();
    this.onTenantChange();
    this.applyColumnFilters();
    this.filterStatusForTableData();
  }
  applyFilters() {
    // this.applyDateFilter(this.selectedOption);
    this.applyTextFilter();
    // console.warn('afterSearch', this.filteredData);
    this.applyColumnFilters();
    this.expandVisible = !this.expandVisible;
  }
  onSaveApply(data: any) {
    this.$store.commit('startLoading');
    const filterToBeSaved = {
      msspSelected: this.mssp,
      tenantSelected: this.tenant,
      productSelected: this.selectedProduct,
      serviceSelected: this.selectedService,
      min: this.min,
      max: this.max,
      startdate: this.startdate,
      expirydate: this.expirydate,
      selectedColumns: this.selectedColumnKeys.filter(ele => ele !== null && ele !== undefined && typeof (ele) !== 'object'),
      statusSelected: this.status,
    };
    // console.warn('sel4', this.selectedColumnKeys);
    this.$store.commit('TenantManagementStoreModule/setCustomisedColumns', { customisedColumns: this.selectedColumnKeys });
    const formattedFilterObj = JSON.stringify(filterToBeSaved);
    MswApiService.tenant.postFilterPreference(formattedFilterObj)
      .then((resp: any) => { // tslint:disable-line
        if (!this.selectingColumn) {
          // this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
        }
        this.filtersClicked = true;
        if (data !== 'tenantChange') {
          this.preFilter();
        }
        this.selectingColumn = false;
        this.$store.commit('stopLoading');
        this.expandVisible = false;
      })
      .catch(() => {
        this.expandVisible = false;
        this.$store.commit('stopLoading');
      });
  }
  onClear() {
    this.selectedService = [];
    this.selectedProduct = [];
    this.min = '0';
    this.max = '99999';
    this.startdate = '';
    this.expirydate = '';
    this.onSaveApply('');
    this.getTenantMgmtData();
    this.expandVisible = !this.expandVisible;
  }
  /* applyDateFilter(id: string) {
    const recentDate = new Date();
    recentDate.setDate(recentDate.getDate() - 60);
    this.filteredData = [...this.tableData];
    if (id === 'recent') {
      this.filteredData = this.tableData.filter((order) => {
        return new Date(order.date) >= recentDate;
      });
    }
  } */
  getMenuItems(data: any) {
    const menuItems = [];
    if (data.editAllowed === 'YES') {
      menuItems.push({ id: 'edit', content: String(this.$t('tenantMgmt.page.tooltips.editProduct')), icons: [{ name: 'pencil' }] });
    }
    if (data.showConsoleIcon === 'YES') {
      menuItems.push({ id: 'monitoring', content: String(this.$t('tenantMgmt.page.tooltips.console')), icons: [{ name: 'monitoring' }] });
    }
    if (data.showDownloadCSV === 'YES') {
      menuItems.push({ id: 'download', content: String(this.$t('tenantMgmt.page.csv')), icons: [{ name: 'download' }] });
      menuItems.push({ id: 'downloadXls', content: String(this.$t('tenantMgmt.page.xls')), icons: [{ name: 'download' }] });
    }
    if (data.transferAllowed === 'YES') {
      menuItems.push({ id: 'transfer', content: String(this.$t('tenantMgmt.page.transfer')), icons: [{ name: 'topo-change' }] });
    }

    if (data.deleteAllowed === 'YES') {
      menuItems.push({ id: 'delete', content: String(this.$t('tenantMgmt.page.delete')), icons: [{ name: 'trash' }] });
    }
    if (data.removeMsspMonthlyAllowed === 'YES') {
      menuItems.push({ id: 'convertto', content: String(this.$t('tenantMgmt.page.convertto')), icons: [{ name: 'app-remove' }] });
    }
    return menuItems;
  }
  get menuItems(): DropMenuItem[] {

    return [
      // { id: 'edit', content: String(this.$t('tenantMgmt.page.editProduct')), icons: [{ name: 'pencil' }] },
      { id: 'download', content: String(this.$t('tenantMgmt.page.csv')), icons: [{ name: 'download' }] },
      { id: 'transfer', content: String(this.$t('tenantMgmt.page.transfer')), icons: [{ name: 'topo-change' }] },
      { id: 'delete', content: String(this.$t('tenantMgmt.page.delete')), icons: [{ name: 'trash' }] },
      { id: 'convertto', content: String(this.$t('tenantMgmt.page.convertto')), icons: [{ name: 'app-remove' }] },
    ];
  }
  private onSelectItem(id: any, data: any) {
    let entry: any = {};
    const selectedEntry:any = this.formatTableData()
    .filter((obj: any) => {
      obj.entries.map((obj1: any) => {
        if (obj1._key === data.entry._key) {
          entry = obj1;
        }
      });
      return obj.entries.find((obj1: any) => obj1._key === data.entry._key);
    });
    selectedEntry[0].entries = [entry];
    // console.warn('entry', entry);
    if (id === 'download') {
      this.visible = true;
      setTimeout(() => {
        this.visible = false;
      }, 5000); // tslint:disable-line
      this.exportData(selectedEntry, 'csv');
    } else if (id === 'downloadXls') {
      this.visible = true;
      setTimeout(() => {
        this.visible = false;
      }, 5000); // tslint:disable-line
      this.exportData(selectedEntry, 'xls');
    } else if (id === 'transfer') {
      this.visible = true;
      data.entry.msspId = selectedEntry[0].msspId;
      this.transfer(data.entry);
    } else if (id === 'delete') {
      this.deleteEntry(data.entry);
    } else if (id === 'convertto') {
      let serCount: any = 0;
      this.filteredData.map((obj: any) => {
        obj.entries.map((ele: any) => {
          if (ele.serNo === data.entry.serNo) {
            serCount = serCount + 1;
            // console.warn('ele', ele.serNo, data.entry.serNo, serCount, this.filteredData);
          }
        });
      });
      // console.warn('sr', serCount, data.entry);
      confirmService.confirm({
        status: 'informational',
        title: 'Confirmation',
        message: String(this.$t('tenantMgmt.page.messages.removeProd')),
        buttons: [{ key: 'cancel', name: String(this.$t('tenantMgmt.page.cancel')) }, { key: 'ok', name: String(this.$t('tenantMgmt.page.ok')) }],
      })
        .then((key) => {
          if (key === 'ok') {
            if (serCount > 1) {
              this.allocateProductServices(data.entry);
            } else {
              this.convertToMssp(data.entry);
            }
          } // to clear cache and pull the latest after deroll
          const clear = {
            endDate: '',
            filterByProductType:'',
            forceFetch: true,
            friendlyNameOrSerial: '',
            isForced : true,
            isPaged : 'YES',
            lastRegistered: '-1',
            pageNumber : 1,
            pageSize : 50,
            productGroupName: '',
            showDownloadsAvailable: false,
            showExpiredProducts:false,
            startDate: '',
          };
          this.$store.dispatch(
            'MswProductsStoreModule/getProductsList', clear,
          );
        });
    } else if (id === 'edit') {
      this.onMoveOut();
      this.productModalMode = 'edit';
      this.onProductEdit(data.entry);
    } else if (id === 'monitoring') {
      this.onMoveOut();
      this.onConsoleClick(data.entry);
    }
    this.configKey = '';
    setTimeout(() => {
      this.visible = false;
      // selectedEntry[0].entries = [];
      // selectedEntry[0].entries.push(entry);
    }, 5000); // tslint:disable-line
  }
  transfer(data: any) {
    this.customersList = this.fullCustomerist;
    let element: any = {};
    this.filteredData.filter((ele: any) => {
      ele.entries.map((ele1: any) => {
        if (ele1._key === data._key) {
          element = ele;
        }
      });
    });
    const selectedTenant = this.customersList.filter(x => x.productGroupName !== element.tenant);
    this.customersList = [...selectedTenant];
    this.selectedProductsForActions = [];
    this.selectedProductsForActions = ([data]);
    this.openMultiProductAction = 'transfer';
  }
  transferSuccess() {
    this.visible = true;
    // console.warn('called transfer sucess method');
    setTimeout(() => {
      // this.getMsspProductDetails();
      // this.refresh();
      this.onSaveApply('');
      this.getTenantMgmtData();
      // this.preFilter();
    }, 3000); // tslint:disable-line
  }
  deleteEntry(data: any) {
    this.selectedProductsForActions = [data];
    this.isOpenDeleteModal = true;
  }
  handleDelete() {
    this.configKey = '';
    this.isOpenDeleteModal = false;
    this.getMsspProductDetails();
    // this.preFilter();
  }
  allocateProductServices(data: any) {
    this.$store.commit('startLoading');
    const removeData: any = {
      ProductID: data.productId,
      serviceId: data.serviceID,
      nodeCount: data.units === 'N/A' || 'No upper limit' ? '99999' : (data.units),
      expirationDate: data.expirydate,
      regionName: '',
      regionID: '',
      serialNumber: data.serNo,
      friendlyName: data.friendlyName,
      isHA: data.isHA ? 'YES' : 'NO',
      expireService: 'YES',
    };
    try {
      return new Promise((res: any, rej: any) => {
        MswApiService.tenant.editProductProvision(removeData)
      .then((resp: any) => {
        setTimeout(() => {
          this.$store.commit('stopLoading');
        }, 5000); // tslint:disable-line
        if (resp.operationStatus === 'NOK') {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
          rej(resp);
        } else {
          this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
          this.refresh();
          // this.preFilter();
          // console.warn('data.key', data);
          this.configKey = (this.configKey !== data._key  ? data._key : '');
          res(resp);
        }
      });
      });
    } catch {
      this.$store.commit('stopLoading');
    }
  }
  convertToMssp(data: any) {
    this.$store.commit('startLoading');
    const transferData: any = {
      serialNumber: data.serNo,
      Mode: 'DEROLL',
    };
    MswApiService.tenant.convertToMssp(transferData)
    .then((resp: any) => {
      setTimeout(() => {
        this.$store.commit('stopLoading');
      }, 5000); // tslint:disable-line
      this.refresh();
      // this.preFilter();
      this.$store.commit('enqueueMessage', { infoType: resp.operationStatus === 'OK' ? 'success' : 'failed', infoMsg: resp.msgDesc });
      this.configKey = (this.configKey !== data[0]._key  ? data[0]._key : '');
    });
  }
  onSelectFilter(/* filter: string */) {
  }

  removeColFilter(id: number) {
    this.selectedColumnFilters[id].newSearchText = '';
    this.selectedColumnFilters[id].isNonEditMode = false;
    this.selectedColumnFilters.splice(id, 1);
    this.applyFilters();
  }

  handleColSearchText(index: any) {
    this.selectedColumnFilters[index].isNonEditMode = true;
    this.selectedColumnFilters[index].newSearchText = this.selectedColumnFilters[index].searchText;
    this.selectedColumnFilters[index].searchText = '';
    this.applyFilters();
  }

  applyColumnFilters(returnArr: boolean = false) {
    // this.applyTextFilter();
    // this.filtersClicked = true;
    let data: TableEntryGroup[] = _.cloneDeep(this.filterOptionsData) ;
    if (this.selectedProduct.length > 0) {
      this.ifColumnSelected = false;
      if (!this.selectedColumnKeys.includes('product')) {
        this.selectedColumnKeys.push('product') ;
      }
      const tempObj: any = [];
      data.map((item:any) =>  {
        let obj:any = [];
        const entry = item.entries.filter((item1: any) => {
          // item1._expandable = false;
          // if (item1._expandable) {
          //   this.onEntryExpanding({ entryKey : item1._key, expanding: false });
          // }
          return this.selectedProduct.includes(item1.product);
        });
        if (entry.length > 0) {
          obj = item;
          obj.entries = entry;
          tempObj.push(obj);
        }
      });
      data = tempObj;
      this.filteredData = data;
    }
    if (this.selectedProduct.length === 0 && this.selectedColumnKeys.includes('product') && !this.ifColumnSelected) {
      const remove: any = this.selectedColumnKeys.indexOf('product');
      this.selectedColumnKeys.splice(remove, 1);
      // console.warn('sel2', this.selectedColumnKeys);
      this.ifColumnSelected = true;
    }
    if (this.selectedService.length > 0) {
      const tempObj: any = [];
      data.map((item:any) =>  {
        let obj:any = [];
        const service:any = [];
        const prod: any = [];
        this.selectedService.map((obj:any) => {
          prod.push(obj.split('-'));
          this.msspPrefilter.Products.map((obj1:any) => {
            // console.warn('ifProd');
            obj1.Services.map((ele: any) => {
              if (obj.includes(ele.ServiceName)) {
                service.push(ele.ServiceID);
              }
            });
          });
        });
        // console.warn('se', service, this.selectedService, prod);
        const entry = item.entries.filter((item1: any) => {
          // item1._expandable = false;
          // if (item1._expandable) {
          //   this.onEntryExpanding({ entryKey : item1._key, expanding: false });
          // }
          // console.warn('find', item1.product, service.includes(item1.serviceID));
          return service.includes(item1.serviceID);
        });
        // console.warn('en', entry);
        if (entry.length > 0) {
          obj = item;
          obj.entries = entry;
          tempObj.push(obj);
        }
      });
      data = tempObj;
      this.filteredData = data;
    }
    this.min = this.min === '' ? '0' : this.min;
    this.max = this.max === '' ? '99999' : this.max;
    if (this.min !== '0' && this.max === '99999') {
      const tempObj: any = [];
      data.map((item:any) =>  {
        const entry = item.entries.filter((item: any) => {
          // item._expandable = false;
          // if (item._expandable) {
          //   this.onEntryExpanding({ entryKey : item._key, expanding: false });
          // }
          return Number(item.units) >= Number(this.min) || (item.units) === 'N/A';
        });
        if (entry.length > 0) {
          const obj = item;
          obj.entries = entry;
          tempObj.push(obj);
        }
      });
      data = tempObj;
      this.filteredData = data;
    } else if (this.max !== '99999' && this.min === '0') {
      const tempObj: any = [];
      data.map((item:any) =>  {
        const entry = item.entries.filter((item1: any) => {
          // item1._expandable = false;
          // if (item1._expandable) {
          //   this.onEntryExpanding({ entryKey : item1._key, expanding: false });
          // }
          return Number(item1.units) <= Number(this.max);
        });
        if (entry.length > 0) {
          const obj = item;
          obj.entries = entry;
          tempObj.push(obj);
        }
      });
      data = tempObj;
      this.filteredData = data;
    } else if (this.min !== '0' && this.max !== '99999') {
      const tempObj: any = [];
      data.map((item:any) =>  {
        const entry = item.entries.filter((item1: any) => {
          // item1._expandable = false;
          // if (item1._expandable) {
          //   this.onEntryExpanding({ entryKey : item1._key, expanding: false });
          // }
          return Number(item1.units) <= Number(this.max) && Number(item1.units) >= Number(this.min);
        });
        if (entry.length > 0) {
          const obj = item;
          obj.entries = entry;
          tempObj.push(obj);
        }
      });
      data = tempObj;
      this.filteredData = data;
    } else {
      this.filteredData = this.tableData;
    }
    if (this.startdate !==  '') {
      this.ifColumnSelected = false;
      if (!this.selectedColumnKeys.includes('startdate')) {
        this.selectedColumnKeys.push('startdate');
      }
      const datearray = this.startdate.split('/');
      const newdate: any = datearray[0].length !== 2 ? '0'.concat(datearray[0], '/', datearray[1], '/', datearray[2])
      : datearray[0].concat('/', datearray[1], '/', datearray[2]);
      const tempObj: any = [];
      data.map((item:any) =>  {
        const entry:any = [];
        item.entries.filter((item1: any) => {
          // item1._expandable = false;
          // if (item1._expandable) {
          //   this.onEntryExpanding({ entryKey : item1._key, expanding: false });
          // }
          // console.warn('newDate', newdate, item1.startdate, item1.startdate === newdate, item1.startdate.includes(newdate));
          if (item1.startdate.includes(newdate)) {
            entry.push(item1);
          }
        });
        if (entry.length > 0) {
          const obj = item;
          obj.entries = entry;
          tempObj.push(obj);
        }
        data = [...tempObj];
        this.filteredData = data;
      });
    }
    if (this.startdate === '' && this.selectedColumnKeys.includes('startdate') && !this.ifColumnSelected) {
      const remove: any = this.selectedColumnKeys.indexOf('startdate');
      this.selectedColumnKeys.splice(remove, 1);
      // console.warn('sel5', this.selectedColumnKeys);
      this.ifColumnSelected = true;
    }
    if (this.expirydate !== '') {
      const datearray = this.expirydate.split('/');
      const newdate: any = datearray[0].length !== 2 ? '0'.concat(datearray[0], '/', datearray[1], '/', datearray[2])
      : datearray[0].concat('/', datearray[1], '/', datearray[2]);
      const tempObj: any = [];
      data.map((item:any) =>  {
        const entry:any = [];
        item.entries.filter((item1: any) => {
          // item1._expandable = false;
          // if (item1._expandable) {
          //   this.onEntryExpanding({ entryKey : item1._key, expanding: false });
          // }
          // console.warn('newDate1', newdate, item1.expirydate, item1.expirydate === newdate, item1.expirydate.includes(newdate));
          if (item1.expirydate.includes(newdate)) {
            entry.push(item1);
          }
        });
        if (entry.length > 0) {
          const obj = item;
          obj.entries = entry;
          tempObj.push(obj);
        }
        data = [...tempObj];
        this.filteredData = data;
      });
    }
    // console.warn('pic3', this.filteredData);
    this.filteredData = data;
    this.data = this.filteredData;
    this.addExpandables();
    // console.warn('in columnFilter', this.filteredData);
    this.setMultiple();
    // console.warn('pic4', this.filteredData);
    this.infiniteTableData = this.filteredData;
    // this.filterOptionsData = data;
    if (returnArr) return this.infiniteTableData;
  }

  /* removeColFilters() {
    this.selectedColumnFilters.forEach((item, index) => { // tslint:disable-line
      this.selectedColumnFilters[index].newSearchText = '';
      this.selectedColumnFilters[index].isNonEditMode = false;
    });
    this.selectedColumnFilters = [];
    this.applyFilters();
  } */
  searchFilter() {
    setTimeout(() => {
      this.applyTextFilter();
    }, 1000); // tslint:disable-line
  }
  applyTextFilter() {
    this.onMoveOut();
    let filterApplied: boolean = false;
    if (this.selectedProduct.length !== 0 || this.selectedService.length !== 0 ||
    this.min !== '' || this.max !== '' || this.startDate !== '' || this.expirydate !== '') {
      filterApplied = true;
    } else {
      filterApplied = false;
    }
    let searchData: any;
    filterApplied ? searchData = this.applyColumnFilters(true) : searchData = this.formatTableData();
    if (!this.searchText) {
      return this.infiniteTableData = searchData;
    }
    let data: any = searchData;
    // tslint:disable-next-line
    this.searchTextFilter =(this.searchText).replace(/\s/g, "");
    const tempObj: any = [];
    data.map((row:any) => {
      this.filteredData = [];
      const subEntry: any = [];
      let obj: any = [];
      let flag: any = false;
      for (const key in row) {
        if (Object.prototype.hasOwnProperty.call(row, key)) {
          if ((key === 'msspp' || key === 'tenant') && row[key].toString()
          .toLocaleLowerCase()
          .includes(this.searchTextFilter.toString()
          .toLocaleLowerCase()
          .trim())) {
            flag = true;
            obj = row;
            // return true;
          }
          if (key === 'entries' && !flag) {
            obj = row;
            // obj.entries = [];
            row[key].map((ele:any) => {
              let eleAdded: boolean = false;
              for (const entry in ele) {
                if (ele.hasOwnProperty(entry) && ele[entry]) {
                  if (ele[entry].toString()
                  .toLocaleLowerCase()
                  .includes(this.searchTextFilter.toString()
                  .toLocaleLowerCase()
                  .trim())) {
                    // ele._expandable = false;
                    // if (ele._expandable) {
                    //   this.onEntryExpanding({ entryKey : ele._key, expanding: false });
                    // }
                    subEntry.push(ele);
                    eleAdded = true;
                  }
                }
                if (eleAdded) return false;
              }
            });
            if (subEntry.length > 0) obj.entries = subEntry;
          }
        }
      }
      if (subEntry.length > 0 && !flag) {
        // obj.entries = [];
        // obj.entries.push(subEntry);
        tempObj.push(obj);
      } else if (flag) {
        tempObj.push(row);
      }
      data = [...tempObj];
    });
    this.filteredData = data;
    // console.warn('pic1', this.filteredData);
    if (!filterApplied) {
      this.setMultiple();
    }
    this.data = this.filteredData;
    // console.warn('da7', this.data);
    this.infiniteTableData = this.filteredData;
  }
  private onSelectExportItem(itemId: string) {
    this.onMoveOut();
    this.exportData(this.filteredData, itemId);
  }
  exportData(data: any, format: string) {
    // const formattedTableData = _.cloneDeep(this.formatTableData());
    const itemObj: any = [];
    let expData: any = [];
    // console.warn('data', data);
    data.map((ele:any) => {
      const entry: any = [];
      const item: any = (this.formatTableData()
      .find(ele1 => ele.key === ele1.key));
      // console.warn('item', item);
      ele.entries.map((obj:any) => {
        if (obj.multiple) {
          item.entries.map((obj1: any) => {
            if (obj1.serNo === obj.serNo) {
              entry.push(obj1);
            }
          });
        } else {
          entry.push(obj);
        }
      });
      ele.entries = [];
      ele.entries = entry;
      itemObj.push(ele);
    });
    expData = [...expData, ...itemObj];
    // if (mode === 'multiple') {
    //   console.warn('before clonedeep', data);
    //   console.warn('before aggregate', expData);
    //   expData.map((ele:any) => {
    //     formattedTableData.map((forele:any) => {
    //       if (forele.tenantId === ele.tenantId) {
    //         ele.entries = forele.entries;
    //       }
    //       return forele;
    //     });
    //     return ele;
    //   });
    //   console.warn('after aggregate', expData);
    //   this.startExport(this.dataToBeExported(expData), String(this.$t('tenantMgmt.page.tent'))
    //   .concat(format));
    // } else if (mode === 'single') {
    //   const formattedTableData = _.cloneDeep(this.formatTableData());
    //   let expData = formattedTableData.filter((forele:any) => {
    //     if (forele.entries.find((ent:any) => ent.serNo === data.serNo)) {
    //       return forele;
    //     }
    //   });
    //   console.warn('before aggregate', expData);
    //   if (data.multiple === true) {
    //     expData = expData.map((tempele:any) => {
    //       tempele.entries = tempele.entries.filter((ent:any) => ent.serNo === data.serNo);
    //       return tempele;
    //     });
    //   }
    //   console.warn('after aggregate', expData);
    //   this.startExport(this.dataToBeExported(expData), String(this.$t('tenantMgmt.page.tent'))
    //   .concat(format));
    // }
    this.startExport(this.dataToBeExported(expData), String(this.$t('tenantMgmt.page.tent'))
      .concat(format));
  }
  dataToBeExported(exportData: any) {
    // // console.warn(exportData);
    let tempArr: any = [];
    const tempJson: any = [];
    exportData.map((dataItem:any) => {
      // // console.warn(dataItem);
      /* if (this.checkForMasterMsspRole) {
        tempJson.push({ ['Mssp'] : 'Mssp', ['Tenant'] : 'Tenant', ['Friendly Name'] :  'Friendly Name', ['Serial Number'] :  'Serial Number',
          ['Product'] :  '', ['Service'] :  '', ['Licensed Units'] :  '', ['Usage'] :  '', ['Firmware'] :  '',
          ['Registration Date'] :  '', ['Expiry Date'] :  '', ['Status'] :  '' });
      } else {
        tempJson.push({ ['Tenant'] : '', ['Friendly Name'] :  '', ['Serial Number'] :  '',
          ['Product'] :  '', ['Service'] :  '', ['Licensed Units'] :  '', ['Usage'] :  '', ['Firmware'] :  '',
          ['Registration Date'] :  '', ['Expiry Date'] :  '', ['Status'] :  '' });
      } */
      // // console.warn('tempJ', tempJson);
      if (dataItem.entries.length > 0) {
        dataItem.entries.map((key: any) => {
          const obj: any = {};
          this.msspColumnConfig.forEach((item) => {
            if (item.title && item.title !== 'Action') {
              // @ts-ignore
              if (item.title === 'Mssp') {
                obj[item.title] = dataItem.msspp;
              } else if (item.title === 'Tenant') {
                obj[item.title] = dataItem.tenant;
              } else if (item.key === 'startdate') {
                const startDtHeader: any = item.title;
                obj[startDtHeader] = key.dtStartDate;
              } else if (item.key === 'expirydate') {
                const expDtHeader: any = item.title;
                obj[expDtHeader] = key.dtExpiryDate && key.dtExpiryDate !== '' ? key.dtExpiryDate : key.expirydate;
              } else {
                // @ts-ignore
                obj[item.title] = key[item.dataKey] || '';
              }
            }
          });
          tempJson.push(obj);
        });
      } else {
        const obj: any = {};
        this.msspColumnConfig.forEach((item) => {
          if (item.title && item.title !== 'Action') {
            // @ts-ignore
            if (item.title === 'Mssp') {
              obj[item.title] = dataItem.msspp;
            } else if (item.title === 'Tenant') {
              obj[item.title] = dataItem.tenant;
            } else {
              // @ts-ignore
              obj[item.title] = '';
            }
          }
        });
        tempJson.push(obj);
      }
    });
    tempArr = tempArr.concat(tempJson);
    return tempArr;
  }
  removeSearchFilter() {
    this.searchTextFilter = '';
    this.searchText = '';
    this.applyFilters();
  }
  startExport(productsList:any, name:string) {
    const XLSX = require('xlsx');
    const csvContent = this.parseJsontoCsv(productsList);
    const data = encodeURIComponent(csvContent);
    const link = document.createElement('a');
    // if (navigator.msSaveOrOpenBlob) {
    //   const blobObject = name.includes('.xls') ? new Blob([data], { type: 'text/xls;charset=utf-8;' }) :
    //   new Blob([data], { type: 'text/csv;charset=utf-8;' });
    //   link.onclick = function () {
    //     navigator.msSaveOrOpenBlob(blobObject, name);
    //   };
    // } else {
    if (name.includes('.xls')) {
      const excel = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(productsList);
      XLSX.utils.book_append_sheet(excel, ws, String(this.$t('tenantMgmt.page.mgmt')));
      const finalExel = XLSX.writeFile(excel, name.concat('x'));
      const blobOb = new Blob(finalExel, { type: 'text/xls;charset=utf-8;' });
      link.href = URL.createObjectURL(blobOb);
      link.setAttribute('style', 'font-weight: bold');
      link.download = name.concat('x');
    } else {
      link.href = `data:text/csv;charset=utf-8,${data}`;
      link.setAttribute('style', 'font-weight: bold');
      link.download = name;
    }
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => {
      this.visible = false;
    }, 5000); // tslint:disable-line
    // }
  }
  octet(out: any) {
    const buff = new ArrayBuffer(out.length);
    const view = new Uint8Array(buff);
    for (let i = 0; i < out.length; i = i + 1) view[i] = out.length & 0xFF;
    return buff;
  }
  parseJsontoCsv(csvData:any) {
    let csv = ''; // tslint:disable-line
    Object.keys(csvData[0])
                .forEach((item:any) => {
                  csv = `${csv} ${item},`;
                });
    csv += '\r\n';
    for (let row = 0; row < csvData.length; row += 1) {
      let keysAmount = Object.keys(csvData[row]).length;// tslint:disable-line
      let keysCounter = 0;// tslint:disable-line
      for (let key in csvData[row]) {// tslint:disable-line
        /*if (csvData[row][key].indexOf(',') !== -1) {
          csvData[row][key] = csvData[row][key].replace(/,/g, ' & ');
        }*/
        // retaining the comma within the value
        const val = `"${csvData[row][key]}"`;
        csv += (val + (keysCounter + 1 < keysAmount ? ',' : '\r\n'));
        keysCounter += 1;
      }
      keysCounter = 0;
    }
    return csv;
  }
  // usageTitle(h: CreateElement): VNode   {// eslint-disable-line  // tslint:disable-line
  //   return (
  //     <div>
  //     <span>{{}}</span>
  //    <SwIcon  name="info" props-tooltip={this.usageTooltipValue}></SwIcon> </div>
  //   ) as VNode;
  // }
  /* tslint:disable-next-line */
  productFilter(h: CreateElement): VNode   {// eslint-disable-line  // tslint:disable-line
    const prod = this.msspPrefilter.Products.map((obj:any) => {
      return obj.ProductName;
    });
    prod.map((obj:any) => {
      if (this.products.indexOf(obj) === -1) {
        this.products.push(obj);
      }
    });
    return (
      this.products.map((obj:any) => {
        return (
        <div>
        <SwCheckbox name={'products'}
        props-value={ obj }
        props-checked={this.selectedProduct.includes(obj)} with-margin
        on-change={() => {
          if (this.selectedProduct.includes(obj)) {
            this.selectedProduct.splice(this.selectedProduct.indexOf(obj), 1);
          } else {
            this.selectedProduct.push(obj);
          }
          this.onProductSelect();
        }}
        >
          {obj}
        </SwCheckbox>
        </div>
        ) as VNode;
      })
    ) as VNode;
  }
  onProductSelect(initializedFilter:boolean = false) {
    if (!initializedFilter) {
      this.services = [];
    }
    if (this.selectedProduct.length > 0) {
      this.selectedColumnKeys.push('product');
      this.services = [];
      const service: any = [];
      this.selectedProduct.map((obj:any) => {
        const serviceFiltered = this.msspPrefilter.Products.filter((obj1: any) => obj1.ProductName === (obj));
        serviceFiltered[0].Services.map((ele: any) => {
          service.push(ele.ServiceName);
        });
        this.services = service;
      });
    }
  }
  /* tslint:disable-next-line */
  serviceFilter(h: CreateElement) {// eslint-disable-line
    return (
      this.services.map((obj:any) => {
        return (
        <div>
        <SwCheckbox name={ 'services' }
        props-value={ obj }
        props-checked={this.selectedService.includes(obj)} with-margin
        on-change={() => {
          if (this.selectedService.includes(obj)) {
            this.selectedService.splice(this.selectedService.indexOf(obj, 1));
          } else {
            this.selectedService.push(obj);
          }
        }}
        >
          {obj}
        </SwCheckbox>
        </div>
        ) as VNode;
      })
    ) as VNode;
  }
  /* tslint:disable-next-line */
  unitsFilter(h: CreateElement): VNode {// eslint-disable-line
    return (
      <div>
      <span class={[`${cssPrefix}__textfield`]}>Select a range</span>
      <SwTextfield class={[`${cssPrefix}__textfield`]} props-name ={ 'min' } props-placeholder={String(this.$t('tenantMgmt.page.min'))} props-value={ (this.min) }
      on-input={(e: any) => { this.min = e; }}>
      </SwTextfield>
      <span> - </span>
      <SwTextfield class={[`${cssPrefix}__textfield`]} props-name ={ 'max' } props-placeholder={String(this.$t('tenantMgmt.page.max'))} props-value={ this.max }
      on-input={(val: any) => { this.max = val; }}>
      </SwTextfield>
      </div>
    ) as VNode;
  }
  /* tslint:disable-next-line */
  startDateFilter (h: CreateElement): VNode {// eslint-disable-line
    return (
      <div>
      <span class={[`${cssPrefix}__textfield`]}>Date range</span>
      <SwDatetimePicker class={[`${cssPrefix}__textfield`]} props-value={ this.startdate } props-pickerConfig={ this.singlePickerConfig }
      on-input={(newVal: string) => { this.startdate = newVal; this.$emit('input', this.startdate); }}></SwDatetimePicker>
      </div>
    ) as VNode;
  }
  /* tslint:disable-next-line */
  expiryDateFilter (h: CreateElement): VNode {// eslint-disable-line
    return (
      <div>
      <span class={[`${cssPrefix}__textfield`]}>Date range</span>
      <SwDatetimePicker class={[`${cssPrefix}__textfield`]} props-value={ this.expirydate }
      props-pickerConfig={ this.pickerConfig } props-model={ this.expirydate }
      on-input={(newVal: string) => { this.expirydate = newVal; this.$emit('input', this.expirydate); }}></SwDatetimePicker>
      </div>
    ) as VNode;
  }

  clickChecked() {
    this.enableProvisionModal = true;
  }

  onCloseModal() {
    this.enableProvisionModal = false;
  }

  onCloseMsspFormModal() {
    this.doCall = false;
    this.enableMsspFormModal = false;
  }

  processProvisionFn(type: string) {
    this.onMoveOut();
    this.enableProvisionModal = false;
    this.enableMsspFormModal = false;
    this.enableTenantFormModal = false;
    this.enableProductModal = false;
    const msspName: any = (this.msspOptions.find((obj: any) => obj.id === (this.mssp)));
    const tenantName: any = (this.tenantOptions.find((obj: any) => obj.id === (this.tenant)));
    if (type === 'mssp') {
      this.enableMsspFormModal = true;
      this.msspModalMode = 'add';
    }
    if (type === 'tenant') {
      this.$store.commit('TenantManagementStoreModule/setNewTenantModalObject', { newTenantModalObject: '' });
      this.enableTenantFormModal = true;
      this.tenantModalMode = 'add';
      this.msspType = this.mssp !== '-1' || !this.isMastermssp ? '' :'select';
    }
    if (type === 'product') {
      this.enableProductModal = true;
      this.productModalMode = 'add';
    }
    this.resetModalValues(msspName.value, tenantName.value, type);
  }

  resetModalValues (mssp:any, tenant:any, type: string) {
    const msspResetValue: MsspModalObject = {
      MSSPname: '',
      MSSPID: this.mssp !== '-1' ? this.mssp : '',
      emailAddress: '',
      contactName: '',
      companyName: '',
      phoneNumber: '',
      streetAddress: '',
      city: '',
      country: 'US',
      state: '',
      zipCode: '',
      isDefaultGroup: 'YES',
      additionalComments: '',
      province: '',
      firstName: '',
      lastName: '',
      msspNumber: '',
      msspContractid: '',
    };
    let msspId = '';
    if (this.tenant !== '-1') {
      if (this.mssp === '-1') {
        this.msspPrefilter.MSSPs.map((msspEle: any) => {
          if (msspEle.Tenants) {
            msspEle.Tenants.map((tenantEle: any) => {
              if (tenantEle.productGroupId.toString() === this.tenant) {
                msspId = msspEle.MSSPName;
              }
            });
          }
        });
      }
    }
    const tenantResetValue: TenantModalObject = {
      MSSPname:  this.mssp !== '-1' ? mssp : this.tenant !== '-1' ? msspId : '',
      tenantName: type === 'product' ? this.tenant !== '-1' ? tenant : '' : '',
      contactName: '',
      companyName: '',
      emailAddress: '',
      phoneNumber: '',
      streetAddress: '',
      cityName: '',
      countryName: 'US',
      stateName: '',
      zipCode: '',
      additionalMessage: '',
      province: '',
      productGroupId: this.tenant !== '-1' ? this.tenant : '',
      tenantNumber: '',
      tenantContractId: '',
    };
    const productResetValue: ProductModalObject = {
      MSSPname: this.allMsspClicked ? this.msspOnTenantSelected :this.mssp !== '-1' ? mssp : '',
      MsspId: this.mssp !== '-1' ? this.msspOptions.filter((ele:any) => ele.value === mssp)[0].id :  '',
      tenantName: this.tenant !== '-1' ? tenant : '',
      tenantId: this.tenant !== '-1' ? this.tenantOptions.filter((ele:any) => ele.value === tenant)[0].id : '',
      accessScopeMessage: '',
      authCode: '',
      serialNumber: '',
      friendlyName: '',
      performFurtherValidation: false,
      isdefaultgroupAssignedtoTenant: false,
      productDetails: [{
        productName: this.tenant !== '' ? '' : 'Product 1',
        productId: '',
        serviceName: '',
        serviceId: '',
        unitSelected: 'noUpperLimit',
        expiryType: 'Never',
        regionSelected: '',
        platform: '',
        showHA: '',
      }],
    };
    // // console.warn('prodReset', productResetValue.tenantName);
    this.msspOnTenantSelected = '';
    this.allMsspClicked = false;
    this.$store.commit('TenantManagementStoreModule/setNewMsspModalObject', { newMsspModalObject: msspResetValue });
    this.$store.commit('TenantManagementStoreModule/setNewTenantModalObject', { newTenantModalObject: tenantResetValue });
    this.$store.commit('TenantManagementStoreModule/setNewProductModalObject', { newProductModalObject: productResetValue });
    // this.setNewProductModalObject({ newProductModalObject: {
    //   MSSPname: this.allMsspClicked ? this.msspOnTenantSelected :this.mssp !== '-1' ? mssp : '',
    //   MsspId: this.mssp !== '-1' ? this.msspOptions.filter((ele:any) => ele.value === mssp)[0].id :  '',
    //   tenantName: this.tenant !== '-1' ? tenant : '',
    //   tenantId: this.tenant !== '-1' ? this.tenantOptions.filter((ele:any) => ele.value === tenant)[0].id : '',
    //   accessScopeMessage: '',
    //   authCode: '',
    //   serialNumber: '',
    //   friendlyName: '',
    //   performFurtherValidation: false,
    //   isdefaultgroupAssignedtoTenant: false,
    //   productDetails: [{
    //     productName: this.tenant !== '' ? '' : 'Product 1',
    //     productId: '',
    //     serviceName: '',
    //     serviceId: '',
    //     unitSelected: 'noUpperLimit',
    //     expiryType: 'Never',
    //     regionSelected: '',
    //     platform: '',
    //     showHA: '',
    //   }],
    // } });
  }
  nextTenantClickFn() {
    this.enableProvisionModal = false;
    this.enableMsspFormModal = false;
    this.enableTenantFormModal = true;
    this.tenantModalMode = 'add';
    this.enableProductModal = false;
    this.msspType = '';
    this.getTenantMgmtData(false);
  }

  nextProductClickFn(data: any) {
    this.enableProvisionModal = false;
    this.enableMsspFormModal = false;
    this.enableTenantFormModal = false;
    this.enableProductModal = true;
    this.msspFiltered = true;
    this.tenantFiltered = true;
    console.warn('dta', data);
    // this.selectedMSSPID = data.MSSPID || '';
    // this.selectedTenantID = data.tenantID || '';
    this.productModalMode = 'add';
    this.getTenantMgmtData(false);
  }
  onSaveCloseMsspModalFn() {
    this.doCall = false;
    this.getTenantMgmtData();
    this.onCloseMsspFormModal();
  }

  onCloseTenantFormModal() {
    this.doCall = false;
    this.enableTenantFormModal = false;
  }

  onCloseProductFormModal(val: any) {
    localStorage.setItem('tenants', '');
    this.doCall = false;
    this.enableProvisionModal = false;
    this.enableMsspFormModal = false;
    this.enableTenantFormModal = false;
    this.enableProductModal = false;
    this.selectedMSSPID = '';
    this.selectedTenantID = '';
    this.msspFiltered = false;
    this.tenantFiltered = false;
    this.selProductRegion = '';
    if (val) {
      this.getTenantMgmtData();
    }
  }
  callMgmt() {
    // console.warn('callMgmt called');
    this.getTenantMgmtData();
  }
  onSaveCloseTenantModalFn() {
    this.doCall = false;
    this.getTenantMgmtData();
    this.onCloseTenantFormModal();
  }

  onSaveCloseProductModalFn() {
    this.doCall = false;
    // this.getTenantMgmtData();
    this.onCloseProductFormModal(true);
    if (this.productModalMode === 'add') {
      this.enableProductSummary = true;
    }
  }

  centerProductModal() {
    this.$nextTick(() => {
      const productModal: any = this.$refs.productModal as SwModal;
      productModal?.recenter();
    });
  }

  applicableMsspProductServicesApiCompleted() {
    this.centerProductModal();
  }

  msspApplicancesApiCompleted() {
    this.centerProductModal();
  }

  onOffSSLvpn() {
    this.getTenantMgmtData();
  }

  onCloseProductSummaryModal() {
    this.doCall = false;
    this.enableProductSummary = false;
  }
  private onLoadMore() {
    this.populateData(this.infiniteTableData.length, Math.max(2, 10));
  }
  private populateData(start: number, length: number) {
    if (length <= 0) { return; }
    if (this.infiniteTableData.length < this.filteredData.length) {
      let count = 0;
      for (; count < length && (start + count) < this.filteredData.length; count += 1) {
        this.infiniteTableData.push(this.filteredData[start + count]);
      }
    }
  }

  /* tslint:disable-next-line */
  async closePendoConsentdDialog(dialogResp: boolean) {
    this.showPendoConsentModal = false;
    if (JSON.parse((localStorage as any).getItem('enablePendo'))) {
      this.startPendoAnalytics();
    }
    // if (dialogResp) {
    // }
  }

  /* tslint:disable-next-line */
  getFloatActions(entry: TableEntry, index: number, scope: any = this): TableEntryFloatAction[] {
    const mssp = scope.msspPrefilter.MSSPs.filter((val:any) => val.MSSPName === entry.msspp)[0];
    const tenant = mssp.Tenants.filter((val:any) => val.TenantName === entry.tenant)[0];
    // // console.warn(mssp);
    const floatingActions = [];
    this.enableTenantEdit === entry._key;
    if (entry.editTenant === 'YES') {
      floatingActions.push({
        icon: { name: 'pencil', color: 'white' },
        action(entry: any) {
          // scope.onMoveOut();
          scope.enableTenantFormModal = true;
          scope.tenantModalMode = 'edit';
          scope.msspType = 'select';
          const tenantObject = {
            msspName: entry.msspp,
            tenantName: entry.tenant,
            contactName: '',
            companyName: '',
            emailAddress: '',
            phoneNumber: '',
            streetAddress: '',
            cityName: '',
            countryName: '',
            stateName: '',
            zipCode: '',
            additionalMessage: '',
            productGroupId: entry.tenantId,
            tenantNumber: '',
          };
          scope.$store.commit('TenantManagementStoreModule/setNewTenantModalObject', { newTenantModalObject: tenantObject });
        },
        tooltip: {
          content: scope.$t('tenantMgmt.page.tooltips.editTenant')
          .toString(),
        },
      });
    }
    if (tenant?.deleteTenant === 'YES') {
      floatingActions.push({
        icon: { name: 'trash', color: 'white' },
        /* tslint:disable-next-line */
        action(entry: any) {
          confirmService.confirm({
            status: 'informational',
            title: 'Confirmation',
            message: String(scope.$t('tenantMgmt.page.messages.tenDeleteSure')),
            buttons: [{ key: 'cancel', name:  String(scope.$t('tenantMgmt.page.cancel')) }, { key: 'ok', name: String(scope.$t('tenantMgmt.page.ok')) }],
          })
          .then((key) => {
            if (key === 'ok') {
              scope.deleteTenant(tenant);
            }
          });
        },
        tooltip: {
          content: scope.$t('tenantMgmt.page.tooltips.deleteTenant')
          .toString(),
        },
      });
    }
    if (this.isMastermssp) {
      if (entry.editMSSP === 'YES') {
        floatingActions.push({
          icon: { name: 'pencil', color: 'white' },
          action(entry: any) {
            // scope.onMoveOut();
            scope.enableMsspFormModal = true;
            scope.msspModalMode = 'edit';
            const msspObject = {
              MSSPname: entry.msspp,
              emailAddress: '',
              contactName: '',
              companyName: '',
              phoneNumber: '',
              streetAddress: '',
              cityName: '',
              countryName: '',
              stateName: '',
              zipcode: '',
              isDefaultGroup: false,
              MSSPID: entry.msspId,
            };
            scope.$store.commit('TenantManagementStoreModule/setNewMsspModalObject', { newMsspModalObject: msspObject });
          },
          tooltip: {
            content: scope.$t('tenantMgmt.page.tooltips.editMssp')
            .toString(),
          },
        });
      }
      if (mssp?.deleteMSSP === 'YES') {
        floatingActions.push({
          icon: { name: 'trash', color: 'white' },
          /* tslint:disable-next-line */
          action(entry: any) {
            confirmService.confirm({
              status: 'informational',
              title: 'Confirmation',
              message: String(scope.$t('tenantMgmt.page.messages.deleteMssp')),
              buttons: [{ key: 'cancel', name: String(scope.$t('tenantMgmt.page.cancel')) }, { key: 'ok', name: String(scope.$t('tenantMgmt.page.ok')) }],
            })
            .then((key) => {
              scope.onMoveOut();
              if (key === 'ok') {
                scope.deleteMssp(mssp);
              }
            });
          },
          tooltip: {
            content: scope.$t('tenantMgmt.page.tooltips.deleteMssp')
            .toString(),
          },
        });
      }
    }
    return floatingActions;
  }

  onCloseTenantTransferModal() {
    this.openMultiProductAction = '';
  }
}
